// This file is auto-generated by @hey-api/openapi-ts

import type { Options } from '@hey-api/client-fetch';
import { queryOptions, type UseMutationOptions } from '@tanstack/react-query';
import {
  client,
  glacierUsersApiListUsers,
  glacierUsersApiCurrentUser,
  glacierUsersApiRelatedUsers,
  glacierUsersApiUnderwriters,
  glacierUsersApiForgotPasswordEndpoint,
  glacierUsersApiResetPasswordEndpoint,
  glacierPolicyApiListPolicies,
  glacierPolicyApiCreatePolicy,
  glacierPolicyApiGetPolicySummary,
  glacierPolicyApiGetPrintQueue,
  glacierPolicyApiDeletePrintQueue,
  glacierPolicyApiPrintQueue,
  glacierPolicyApiGetPolicy,
  glacierPolicyApiGetLatestTransactionSummary,
  glacierPolicyApiGetLatestTransactionLatestAttempt,
  glacierPolicyApiValidatePolicyFields,
  glacierPolicyApiAssignAgent,
  glacierPolicyApiAssignUnderwriter,
  glacierPolicyApiAssign,
  glacierPolicyApiAssignable,
  glacierPolicyApiGetPolicyWithSummaries,
  glacierPolicyApiGetPolicyPermissions,
  glacierPolicyApiDeclineTransaction,
  glacierPolicyApiDiscardTransaction,
  glacierPolicyApiReopenTransaction,
  glacierPolicyApiAddLocation,
  glacierPolicyApiUpdatePrimaryLocation,
  glacierPolicyApiGetLocation,
  glacierPolicyApiUpdateLocation,
  glacierPolicyApiDeleteLocation,
  glacierPolicyApiGetDentist,
  glacierPolicyApiAddDentist,
  glacierPolicyApiDeleteDentist,
  glacierPolicyApiUpdateBasicDentist,
  glacierPolicyApiUpdateDentistInformation,
  glacierPolicyApiGetDentistInformation,
  glacierPolicyApiUpdateDentistPricing,
  glacierPolicyApiGetDentistPricing,
  glacierPolicyApiUpdateDentistProcedures,
  glacierPolicyApiGetDentistProcedures,
  glacierPolicyApiUpdatePlPracticeOwner,
  glacierPolicyApiGetPracticeOwners,
  glacierPolicyApiUpdatePlCoverage,
  glacierPolicyApiGetPlCoverage,
  glacierPolicyApiUpdatePolicyDetails,
  glacierPolicyApiGetPolicyDetails,
  glacierPolicyApiRefreshCommercialPropertyWithVerisk,
  glacierPolicyApiRefreshCommercialPropertyWithCorelogic,
  glacierPolicyApiAddCommercialPropertyCoverage,
  glacierPolicyApiUpdateCommercialPropertyCoverage,
  glacierPolicyApiDeleteCommercialPropertyCoverage,
  glacierPolicyApiGetCommercialPropertyLocation,
  glacierPolicyApiUpdateCpCoverage,
  glacierPolicyApiGetCommercialPropertyCoverage,
  glacierPolicyApiRatePolicy,
  glacierPolicyApiGetFormulas,
  glacierPolicyApiCreateOwnedEntities,
  glacierPolicyApiGetOwnedEntity,
  glacierPolicyApiUpdatedOwnedEntity,
  glacierPolicyApiDeleteOwnedEntity,
  glacierPolicyApiUpdateGeneralLiability,
  glacierPolicyApiUpdateEmploymentPracticesLiability,
  glacierPolicyApiUpdateErisaAndEmployeeBenefits,
  glacierPolicyApiIssuePolicy,
  glacierPolicyApiCreateMidtermTransaction,
  glacierPolicyApiSetReasonForChange,
  glacierPolicyApiPricePreviewMidtermChange,
  glacierPolicyApiGetAgentAuthority,
  glacierPolicyApiFinalizeMidtermChange,
  glacierPolicyApiCancelMidtermChange,
  glacierPolicyApiRevertTransaction,
  glacierPolicyApiUpdateDentistUnderwritingQuestions,
  glacierPolicyApiPremiumStatement,
  glacierPolicyApiGetSpecialForms,
  glacierPolicyApiConditionalRenewalNotice,
  glacierPolicyApiDownloadRatingWorksheets,
  glacierPolicyApiPremiumRenewalNotice,
  glacierPolicyApiDownloadLookerDashboardPdf,
  glacierPolicyApiDownloadLookerDashboardCsv,
  glacierPolicyApiSpecimenPreview,
  glacierPolicyApiListDocuments,
  glacierPolicyApiUploadDocument,
  glacierPolicyApiDetachDocument,
  glacierPolicyApiUpdateDocument,
  documentIsReady,
  glacierPolicyApiDownloadDocument,
  glacierPolicyApiRegenerateDocument,
  glacierPolicyApiCommitTransactionTest,
  glacierPolicyApiListUnderwriterNotes,
  glacierPolicyApiCreateUnderwriterNotes,
  glacierPolicyApiUpdateUnderwriterNotes,
  glacierPolicyApiDeleteUnderwriterNotes,
  glacierPolicyApiReopenUnlockedAccount,
  glacierPolicyApiCreatePolicyPendingCancellationTransaction,
  glacierPolicyApiListObjectSummaries,
  glacierPolicyApiGetObjectDetails,
  glacierPolicyApiReferPolicy,
  glacierPolicyApiListTransactions,
  glacierPolicyApiGetTransactionDetail,
  glacierPolicyFormsApiPolicyLevelAttachedEndorsements,
  glacierPolicyFormsApiAttachFormToPolicy,
  glacierPolicyFormsApiDetachFormFromPolicy,
  glacierPolicyFormsApiGetAvailableEndorsements,
  glacierPolicyFormsApiAttachFormToDentist,
  glacierPolicyFormsApiDetachFormFromDentist,
  glacierPolicyFormsApiGetDentistAttachedForms,
  glacierPolicyFormsApiGetDentistAvailableEndorsements,
  glacierPolicyFormsApiAttachFormToLocation,
  glacierPolicyFormsApiDetachFormFromLocation,
  glacierPolicyFormsApiGetLocationAttachedForms,
  glacierPolicyFormsApiGetLocationAvailableEndorsements,
  glacierPolicyFormsApiAttachFormToEntity,
  glacierPolicyFormsApiDetachFormFromEntity,
  glacierPolicyFormsApiGetEntityAttachedForms,
  glacierPolicyFormsApiGetEntityAvailableEndorsements,
  glacierPolicyFormsApiRenderForm,
  glacierPolicyFormsApiGetQuestionsByPolicy,
  glacierPolicyFormsApiPostSaveQuestionsAnswersPolicy,
  glacierPolicyFormsApiGetQuestionsByDentist,
  glacierPolicyFormsApiPostSaveQuestionsAnswersDentist,
  glacierPolicyFormsApiGetQuestionsByLocation,
  glacierPolicyFormsApiPostSaveQuestionsAnswersLocation,
  glacierPolicyFormsApiGetQuestionsByEntity,
  glacierPolicyFormsApiPostSaveQuestionsAnswersEntity,
  glacierPolicyConditionsApiListBindingConditions,
  glacierPolicyConditionsApiCreateBindingCondition,
  glacierPolicyConditionsApiUpdateBindingCondition,
  glacierPolicyConditionsApiDeleteBindingCondition,
  glacierPolicyConditionsApiListTermsConditions,
  glacierPolicyConditionsApiCreateTermsCondition,
  glacierPolicyConditionsApiUpdateTermsCondition,
  glacierPolicyConditionsApiDeleteTermsCondition,
  glacierPolicyErpApiGetErpEligibleDates,
  glacierPolicyErpApiGetErpSections,
  glacierPolicyErpApiStartErpEndorsement,
  glacierPolicyErpApiSaveErpSelections,
  glacierOneschemaApiGetJwtToken,
  glacierOneschemaApiBulkUploadPolicies,
  glacierOneschemaApiBulkUploadDentists,
  glacierOneschemaApiBulkUploadLocations,
  glacierAgenciesApiListWritingCompany,
  glacierNewGradApiValidateAgency,
  glacierNewGradApiSaveAnswers,
  glacierNewGradApiGetAnswers,
  glacierNewGradApiPollPayment,
  glacierNewGradApiDownloadQuote,
  glacierNewGradApiDownloadPolicy,
} from '../services.gen';
import type {
  GlacierUsersApiForgotPasswordEndpointData,
  GlacierUsersApiForgotPasswordEndpointError,
  GlacierUsersApiForgotPasswordEndpointResponse,
  GlacierUsersApiResetPasswordEndpointData,
  GlacierUsersApiResetPasswordEndpointError,
  GlacierUsersApiResetPasswordEndpointResponse,
  GlacierPolicyApiCreatePolicyData,
  GlacierPolicyApiCreatePolicyError,
  GlacierPolicyApiCreatePolicyResponse,
  GlacierPolicyApiGetPrintQueueData,
  GlacierPolicyApiDeletePrintQueueData,
  GlacierPolicyApiDeletePrintQueueError,
  GlacierPolicyApiDeletePrintQueueResponse,
  GlacierPolicyApiPrintQueueData,
  GlacierPolicyApiPrintQueueError,
  GlacierPolicyApiPrintQueueResponse,
  GlacierPolicyApiGetPolicyData,
  GlacierPolicyApiGetLatestTransactionSummaryData,
  GlacierPolicyApiGetLatestTransactionLatestAttemptData,
  GlacierPolicyApiValidatePolicyFieldsData,
  GlacierPolicyApiAssignAgentData,
  GlacierPolicyApiAssignAgentError,
  GlacierPolicyApiAssignAgentResponse,
  GlacierPolicyApiAssignUnderwriterData,
  GlacierPolicyApiAssignUnderwriterError,
  GlacierPolicyApiAssignUnderwriterResponse,
  GlacierPolicyApiAssignData,
  GlacierPolicyApiAssignError,
  GlacierPolicyApiAssignResponse,
  GlacierPolicyApiAssignableData,
  GlacierPolicyApiGetPolicyWithSummariesData,
  GlacierPolicyApiGetPolicyPermissionsData,
  GlacierPolicyApiDeclineTransactionData,
  GlacierPolicyApiDeclineTransactionError,
  GlacierPolicyApiDeclineTransactionResponse,
  GlacierPolicyApiDiscardTransactionData,
  GlacierPolicyApiDiscardTransactionError,
  GlacierPolicyApiDiscardTransactionResponse,
  GlacierPolicyApiReopenTransactionData,
  GlacierPolicyApiReopenTransactionError,
  GlacierPolicyApiReopenTransactionResponse,
  GlacierPolicyApiAddLocationData,
  GlacierPolicyApiAddLocationError,
  GlacierPolicyApiAddLocationResponse,
  GlacierPolicyApiUpdatePrimaryLocationData,
  GlacierPolicyApiUpdatePrimaryLocationError,
  GlacierPolicyApiUpdatePrimaryLocationResponse,
  GlacierPolicyApiGetLocationData,
  GlacierPolicyApiUpdateLocationData,
  GlacierPolicyApiUpdateLocationError,
  GlacierPolicyApiUpdateLocationResponse,
  GlacierPolicyApiDeleteLocationData,
  GlacierPolicyApiDeleteLocationError,
  GlacierPolicyApiDeleteLocationResponse,
  GlacierPolicyApiGetDentistData,
  GlacierPolicyApiAddDentistData,
  GlacierPolicyApiAddDentistError,
  GlacierPolicyApiAddDentistResponse,
  GlacierPolicyApiDeleteDentistData,
  GlacierPolicyApiDeleteDentistError,
  GlacierPolicyApiDeleteDentistResponse,
  GlacierPolicyApiUpdateBasicDentistData,
  GlacierPolicyApiUpdateBasicDentistError,
  GlacierPolicyApiUpdateBasicDentistResponse,
  GlacierPolicyApiUpdateDentistInformationData,
  GlacierPolicyApiUpdateDentistInformationError,
  GlacierPolicyApiUpdateDentistInformationResponse,
  GlacierPolicyApiGetDentistInformationData,
  GlacierPolicyApiUpdateDentistPricingData,
  GlacierPolicyApiUpdateDentistPricingError,
  GlacierPolicyApiUpdateDentistPricingResponse,
  GlacierPolicyApiGetDentistPricingData,
  GlacierPolicyApiUpdateDentistProceduresData,
  GlacierPolicyApiUpdateDentistProceduresError,
  GlacierPolicyApiUpdateDentistProceduresResponse,
  GlacierPolicyApiGetDentistProceduresData,
  GlacierPolicyApiUpdatePlPracticeOwnerData,
  GlacierPolicyApiUpdatePlPracticeOwnerError,
  GlacierPolicyApiUpdatePlPracticeOwnerResponse,
  GlacierPolicyApiGetPracticeOwnersData,
  GlacierPolicyApiUpdatePlCoverageData,
  GlacierPolicyApiUpdatePlCoverageError,
  GlacierPolicyApiUpdatePlCoverageResponse,
  GlacierPolicyApiGetPlCoverageData,
  GlacierPolicyApiUpdatePolicyDetailsData,
  GlacierPolicyApiUpdatePolicyDetailsError,
  GlacierPolicyApiUpdatePolicyDetailsResponse,
  GlacierPolicyApiGetPolicyDetailsData,
  GlacierPolicyApiRefreshCommercialPropertyWithVeriskData,
  GlacierPolicyApiRefreshCommercialPropertyWithVeriskError,
  GlacierPolicyApiRefreshCommercialPropertyWithVeriskResponse,
  GlacierPolicyApiRefreshCommercialPropertyWithCorelogicData,
  GlacierPolicyApiRefreshCommercialPropertyWithCorelogicError,
  GlacierPolicyApiRefreshCommercialPropertyWithCorelogicResponse,
  GlacierPolicyApiAddCommercialPropertyCoverageData,
  GlacierPolicyApiAddCommercialPropertyCoverageError,
  GlacierPolicyApiAddCommercialPropertyCoverageResponse,
  GlacierPolicyApiUpdateCommercialPropertyCoverageData,
  GlacierPolicyApiUpdateCommercialPropertyCoverageError,
  GlacierPolicyApiUpdateCommercialPropertyCoverageResponse,
  GlacierPolicyApiDeleteCommercialPropertyCoverageData,
  GlacierPolicyApiDeleteCommercialPropertyCoverageError,
  GlacierPolicyApiDeleteCommercialPropertyCoverageResponse,
  GlacierPolicyApiGetCommercialPropertyLocationData,
  GlacierPolicyApiUpdateCpCoverageData,
  GlacierPolicyApiUpdateCpCoverageError,
  GlacierPolicyApiUpdateCpCoverageResponse,
  GlacierPolicyApiGetCommercialPropertyCoverageData,
  GlacierPolicyApiRatePolicyData,
  GlacierPolicyApiRatePolicyError,
  GlacierPolicyApiRatePolicyResponse,
  GlacierPolicyApiGetFormulasData,
  GlacierPolicyApiCreateOwnedEntitiesData,
  GlacierPolicyApiCreateOwnedEntitiesError,
  GlacierPolicyApiCreateOwnedEntitiesResponse,
  GlacierPolicyApiGetOwnedEntityData,
  GlacierPolicyApiUpdatedOwnedEntityData,
  GlacierPolicyApiUpdatedOwnedEntityError,
  GlacierPolicyApiUpdatedOwnedEntityResponse,
  GlacierPolicyApiDeleteOwnedEntityData,
  GlacierPolicyApiDeleteOwnedEntityError,
  GlacierPolicyApiDeleteOwnedEntityResponse,
  GlacierPolicyApiUpdateGeneralLiabilityData,
  GlacierPolicyApiUpdateGeneralLiabilityError,
  GlacierPolicyApiUpdateGeneralLiabilityResponse,
  GlacierPolicyApiUpdateEmploymentPracticesLiabilityData,
  GlacierPolicyApiUpdateEmploymentPracticesLiabilityError,
  GlacierPolicyApiUpdateEmploymentPracticesLiabilityResponse,
  GlacierPolicyApiUpdateErisaAndEmployeeBenefitsData,
  GlacierPolicyApiUpdateErisaAndEmployeeBenefitsError,
  GlacierPolicyApiUpdateErisaAndEmployeeBenefitsResponse,
  GlacierPolicyApiIssuePolicyData,
  GlacierPolicyApiIssuePolicyError,
  GlacierPolicyApiIssuePolicyResponse,
  GlacierPolicyApiCreateMidtermTransactionData,
  GlacierPolicyApiCreateMidtermTransactionError,
  GlacierPolicyApiCreateMidtermTransactionResponse,
  GlacierPolicyApiSetReasonForChangeData,
  GlacierPolicyApiSetReasonForChangeError,
  GlacierPolicyApiSetReasonForChangeResponse,
  GlacierPolicyApiPricePreviewMidtermChangeData,
  GlacierPolicyApiGetAgentAuthorityData,
  GlacierPolicyApiFinalizeMidtermChangeData,
  GlacierPolicyApiFinalizeMidtermChangeError,
  GlacierPolicyApiFinalizeMidtermChangeResponse,
  GlacierPolicyApiCancelMidtermChangeData,
  GlacierPolicyApiCancelMidtermChangeError,
  GlacierPolicyApiCancelMidtermChangeResponse,
  GlacierPolicyApiRevertTransactionData,
  GlacierPolicyApiRevertTransactionError,
  GlacierPolicyApiRevertTransactionResponse,
  GlacierPolicyApiUpdateDentistUnderwritingQuestionsData,
  GlacierPolicyApiUpdateDentistUnderwritingQuestionsError,
  GlacierPolicyApiUpdateDentistUnderwritingQuestionsResponse,
  GlacierPolicyApiPremiumStatementData,
  GlacierPolicyApiPremiumStatementError,
  GlacierPolicyApiPremiumStatementResponse,
  GlacierPolicyApiGetSpecialFormsData,
  GlacierPolicyApiGetSpecialFormsError,
  GlacierPolicyApiGetSpecialFormsResponse,
  GlacierPolicyApiConditionalRenewalNoticeData,
  GlacierPolicyApiConditionalRenewalNoticeError,
  GlacierPolicyApiConditionalRenewalNoticeResponse,
  GlacierPolicyApiDownloadRatingWorksheetsData,
  GlacierPolicyApiDownloadRatingWorksheetsError,
  GlacierPolicyApiDownloadRatingWorksheetsResponse,
  GlacierPolicyApiPremiumRenewalNoticeData,
  GlacierPolicyApiPremiumRenewalNoticeError,
  GlacierPolicyApiPremiumRenewalNoticeResponse,
  GlacierPolicyApiDownloadLookerDashboardPdfData,
  GlacierPolicyApiDownloadLookerDashboardPdfError,
  GlacierPolicyApiDownloadLookerDashboardPdfResponse,
  GlacierPolicyApiDownloadLookerDashboardCsvData,
  GlacierPolicyApiDownloadLookerDashboardCsvError,
  GlacierPolicyApiDownloadLookerDashboardCsvResponse,
  GlacierPolicyApiSpecimenPreviewData,
  GlacierPolicyApiListDocumentsData,
  GlacierPolicyApiUploadDocumentData,
  GlacierPolicyApiUploadDocumentError,
  GlacierPolicyApiUploadDocumentResponse,
  GlacierPolicyApiDetachDocumentData,
  GlacierPolicyApiDetachDocumentError,
  GlacierPolicyApiDetachDocumentResponse,
  GlacierPolicyApiUpdateDocumentData,
  GlacierPolicyApiUpdateDocumentError,
  GlacierPolicyApiUpdateDocumentResponse,
  DocumentIsReadyData,
  GlacierPolicyApiDownloadDocumentData,
  GlacierPolicyApiRegenerateDocumentData,
  GlacierPolicyApiRegenerateDocumentError,
  GlacierPolicyApiRegenerateDocumentResponse,
  GlacierPolicyApiCommitTransactionTestData,
  GlacierPolicyApiCommitTransactionTestError,
  GlacierPolicyApiCommitTransactionTestResponse,
  GlacierPolicyApiListUnderwriterNotesData,
  GlacierPolicyApiCreateUnderwriterNotesData,
  GlacierPolicyApiCreateUnderwriterNotesError,
  GlacierPolicyApiCreateUnderwriterNotesResponse,
  GlacierPolicyApiUpdateUnderwriterNotesData,
  GlacierPolicyApiUpdateUnderwriterNotesError,
  GlacierPolicyApiUpdateUnderwriterNotesResponse,
  GlacierPolicyApiDeleteUnderwriterNotesData,
  GlacierPolicyApiDeleteUnderwriterNotesError,
  GlacierPolicyApiDeleteUnderwriterNotesResponse,
  GlacierPolicyApiReopenUnlockedAccountData,
  GlacierPolicyApiReopenUnlockedAccountError,
  GlacierPolicyApiReopenUnlockedAccountResponse,
  GlacierPolicyApiCreatePolicyPendingCancellationTransactionData,
  GlacierPolicyApiCreatePolicyPendingCancellationTransactionError,
  GlacierPolicyApiCreatePolicyPendingCancellationTransactionResponse,
  GlacierPolicyApiListObjectSummariesData,
  GlacierPolicyApiGetObjectDetailsData,
  GlacierPolicyApiReferPolicyData,
  GlacierPolicyApiReferPolicyError,
  GlacierPolicyApiReferPolicyResponse,
  GlacierPolicyApiListTransactionsData,
  GlacierPolicyApiGetTransactionDetailData,
  GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsData,
  GlacierPolicyFormsApiAttachFormToPolicyData,
  GlacierPolicyFormsApiAttachFormToPolicyError,
  GlacierPolicyFormsApiAttachFormToPolicyResponse,
  GlacierPolicyFormsApiDetachFormFromPolicyData,
  GlacierPolicyFormsApiDetachFormFromPolicyError,
  GlacierPolicyFormsApiDetachFormFromPolicyResponse,
  GlacierPolicyFormsApiGetAvailableEndorsementsData,
  GlacierPolicyFormsApiAttachFormToDentistData,
  GlacierPolicyFormsApiAttachFormToDentistError,
  GlacierPolicyFormsApiAttachFormToDentistResponse,
  GlacierPolicyFormsApiDetachFormFromDentistData,
  GlacierPolicyFormsApiDetachFormFromDentistError,
  GlacierPolicyFormsApiDetachFormFromDentistResponse,
  GlacierPolicyFormsApiGetDentistAttachedFormsData,
  GlacierPolicyFormsApiGetDentistAvailableEndorsementsData,
  GlacierPolicyFormsApiAttachFormToLocationData,
  GlacierPolicyFormsApiAttachFormToLocationError,
  GlacierPolicyFormsApiAttachFormToLocationResponse,
  GlacierPolicyFormsApiDetachFormFromLocationData,
  GlacierPolicyFormsApiDetachFormFromLocationError,
  GlacierPolicyFormsApiDetachFormFromLocationResponse,
  GlacierPolicyFormsApiGetLocationAttachedFormsData,
  GlacierPolicyFormsApiGetLocationAvailableEndorsementsData,
  GlacierPolicyFormsApiAttachFormToEntityData,
  GlacierPolicyFormsApiAttachFormToEntityError,
  GlacierPolicyFormsApiAttachFormToEntityResponse,
  GlacierPolicyFormsApiDetachFormFromEntityData,
  GlacierPolicyFormsApiDetachFormFromEntityError,
  GlacierPolicyFormsApiDetachFormFromEntityResponse,
  GlacierPolicyFormsApiGetEntityAttachedFormsData,
  GlacierPolicyFormsApiGetEntityAvailableEndorsementsData,
  GlacierPolicyFormsApiRenderFormData,
  GlacierPolicyFormsApiRenderFormError,
  GlacierPolicyFormsApiRenderFormResponse,
  GlacierPolicyFormsApiGetQuestionsByPolicyData,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyData,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyError,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyResponse,
  GlacierPolicyFormsApiGetQuestionsByDentistData,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistData,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistError,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistResponse,
  GlacierPolicyFormsApiGetQuestionsByLocationData,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationData,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationError,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationResponse,
  GlacierPolicyFormsApiGetQuestionsByEntityData,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityData,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityError,
  GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityResponse,
  GlacierPolicyConditionsApiListBindingConditionsData,
  GlacierPolicyConditionsApiCreateBindingConditionData,
  GlacierPolicyConditionsApiCreateBindingConditionError,
  GlacierPolicyConditionsApiCreateBindingConditionResponse,
  GlacierPolicyConditionsApiUpdateBindingConditionData,
  GlacierPolicyConditionsApiUpdateBindingConditionError,
  GlacierPolicyConditionsApiUpdateBindingConditionResponse,
  GlacierPolicyConditionsApiDeleteBindingConditionData,
  GlacierPolicyConditionsApiDeleteBindingConditionError,
  GlacierPolicyConditionsApiDeleteBindingConditionResponse,
  GlacierPolicyConditionsApiListTermsConditionsData,
  GlacierPolicyConditionsApiCreateTermsConditionData,
  GlacierPolicyConditionsApiCreateTermsConditionError,
  GlacierPolicyConditionsApiCreateTermsConditionResponse,
  GlacierPolicyConditionsApiUpdateTermsConditionData,
  GlacierPolicyConditionsApiUpdateTermsConditionError,
  GlacierPolicyConditionsApiUpdateTermsConditionResponse,
  GlacierPolicyConditionsApiDeleteTermsConditionData,
  GlacierPolicyConditionsApiDeleteTermsConditionError,
  GlacierPolicyConditionsApiDeleteTermsConditionResponse,
  GlacierPolicyErpApiGetErpEligibleDatesData,
  GlacierPolicyErpApiGetErpSectionsData,
  GlacierPolicyErpApiStartErpEndorsementData,
  GlacierPolicyErpApiStartErpEndorsementError,
  GlacierPolicyErpApiStartErpEndorsementResponse,
  GlacierPolicyErpApiSaveErpSelectionsData,
  GlacierPolicyErpApiSaveErpSelectionsError,
  GlacierPolicyErpApiSaveErpSelectionsResponse,
  GlacierOneschemaApiBulkUploadPoliciesData,
  GlacierOneschemaApiBulkUploadPoliciesError,
  GlacierOneschemaApiBulkUploadPoliciesResponse,
  GlacierOneschemaApiBulkUploadDentistsData,
  GlacierOneschemaApiBulkUploadDentistsError,
  GlacierOneschemaApiBulkUploadDentistsResponse,
  GlacierOneschemaApiBulkUploadLocationsData,
  GlacierOneschemaApiBulkUploadLocationsError,
  GlacierOneschemaApiBulkUploadLocationsResponse,
  GlacierNewGradApiValidateAgencyData,
  GlacierNewGradApiValidateAgencyError,
  GlacierNewGradApiValidateAgencyResponse,
  GlacierNewGradApiSaveAnswersData,
  GlacierNewGradApiSaveAnswersError,
  GlacierNewGradApiSaveAnswersResponse,
  GlacierNewGradApiGetAnswersData,
  GlacierNewGradApiPollPaymentData,
  GlacierNewGradApiPollPaymentError,
  GlacierNewGradApiPollPaymentResponse,
  GlacierNewGradApiDownloadQuoteData,
  GlacierNewGradApiDownloadQuoteError,
  GlacierNewGradApiDownloadQuoteResponse,
  GlacierNewGradApiDownloadPolicyData,
  GlacierNewGradApiDownloadPolicyError,
  GlacierNewGradApiDownloadPolicyResponse,
} from '../types.gen';

type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean
): QueryKey<TOptions>[0] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return params;
};

export const glacierUsersApiListUsersQueryKey = (options?: Options) => [
  createQueryKey('glacierUsersApiListUsers', options),
];

export const glacierUsersApiListUsersOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierUsersApiListUsers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierUsersApiListUsersQueryKey(options),
  });
};

export const glacierUsersApiCurrentUserQueryKey = (options?: Options) => [
  createQueryKey('glacierUsersApiCurrentUser', options),
];

export const glacierUsersApiCurrentUserOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierUsersApiCurrentUser({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierUsersApiCurrentUserQueryKey(options),
  });
};

export const glacierUsersApiRelatedUsersQueryKey = (options?: Options) => [
  createQueryKey('glacierUsersApiRelatedUsers', options),
];

export const glacierUsersApiRelatedUsersOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierUsersApiRelatedUsers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierUsersApiRelatedUsersQueryKey(options),
  });
};

export const glacierUsersApiUnderwritersQueryKey = (options?: Options) => [
  createQueryKey('glacierUsersApiUnderwriters', options),
];

export const glacierUsersApiUnderwritersOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierUsersApiUnderwriters({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierUsersApiUnderwritersQueryKey(options),
  });
};

export const glacierUsersApiForgotPasswordEndpointQueryKey = (
  options: Options<GlacierUsersApiForgotPasswordEndpointData>
) => [createQueryKey('glacierUsersApiForgotPasswordEndpoint', options)];

export const glacierUsersApiForgotPasswordEndpointOptions = (
  options: Options<GlacierUsersApiForgotPasswordEndpointData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierUsersApiForgotPasswordEndpoint({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierUsersApiForgotPasswordEndpointQueryKey(options),
  });
};

export const glacierUsersApiForgotPasswordEndpointMutation = (
  options?: Partial<Options<GlacierUsersApiForgotPasswordEndpointData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierUsersApiForgotPasswordEndpointResponse,
    GlacierUsersApiForgotPasswordEndpointError,
    Options<GlacierUsersApiForgotPasswordEndpointData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierUsersApiForgotPasswordEndpoint({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierUsersApiResetPasswordEndpointQueryKey = (
  options: Options<GlacierUsersApiResetPasswordEndpointData>
) => [createQueryKey('glacierUsersApiResetPasswordEndpoint', options)];

export const glacierUsersApiResetPasswordEndpointOptions = (
  options: Options<GlacierUsersApiResetPasswordEndpointData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierUsersApiResetPasswordEndpoint({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierUsersApiResetPasswordEndpointQueryKey(options),
  });
};

export const glacierUsersApiResetPasswordEndpointMutation = (
  options?: Partial<Options<GlacierUsersApiResetPasswordEndpointData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierUsersApiResetPasswordEndpointResponse,
    GlacierUsersApiResetPasswordEndpointError,
    Options<GlacierUsersApiResetPasswordEndpointData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierUsersApiResetPasswordEndpoint({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiListPoliciesQueryKey = (options?: Options) => [
  createQueryKey('glacierPolicyApiListPolicies', options),
];

export const glacierPolicyApiListPoliciesOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiListPolicies({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiListPoliciesQueryKey(options),
  });
};

export const glacierPolicyApiCreatePolicyQueryKey = (
  options: Options<GlacierPolicyApiCreatePolicyData>
) => [createQueryKey('glacierPolicyApiCreatePolicy', options)];

export const glacierPolicyApiCreatePolicyOptions = (
  options: Options<GlacierPolicyApiCreatePolicyData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiCreatePolicy({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiCreatePolicyQueryKey(options),
  });
};

export const glacierPolicyApiCreatePolicyMutation = (
  options?: Partial<Options<GlacierPolicyApiCreatePolicyData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiCreatePolicyResponse,
    GlacierPolicyApiCreatePolicyError,
    Options<GlacierPolicyApiCreatePolicyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiCreatePolicy({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetPolicySummaryQueryKey = (options?: Options) => [
  createQueryKey('glacierPolicyApiGetPolicySummary', options),
];

export const glacierPolicyApiGetPolicySummaryOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetPolicySummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetPolicySummaryQueryKey(options),
  });
};

export const glacierPolicyApiGetPrintQueueQueryKey = (
  options?: Options<GlacierPolicyApiGetPrintQueueData>
) => [createQueryKey('glacierPolicyApiGetPrintQueue', options)];

export const glacierPolicyApiGetPrintQueueOptions = (
  options?: Options<GlacierPolicyApiGetPrintQueueData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetPrintQueue({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetPrintQueueQueryKey(options),
  });
};

export const glacierPolicyApiDeletePrintQueueMutation = (
  options?: Partial<Options<GlacierPolicyApiDeletePrintQueueData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDeletePrintQueueResponse,
    GlacierPolicyApiDeletePrintQueueError,
    Options<GlacierPolicyApiDeletePrintQueueData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiDeletePrintQueue({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiPrintQueueQueryKey = (
  options: Options<GlacierPolicyApiPrintQueueData>
) => [createQueryKey('glacierPolicyApiPrintQueue', options)];

export const glacierPolicyApiPrintQueueOptions = (
  options: Options<GlacierPolicyApiPrintQueueData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiPrintQueue({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiPrintQueueQueryKey(options),
  });
};

export const glacierPolicyApiPrintQueueMutation = (
  options?: Partial<Options<GlacierPolicyApiPrintQueueData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiPrintQueueResponse,
    GlacierPolicyApiPrintQueueError,
    Options<GlacierPolicyApiPrintQueueData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiPrintQueue({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetPolicyQueryKey = (
  options: Options<GlacierPolicyApiGetPolicyData>
) => [createQueryKey('glacierPolicyApiGetPolicy', options)];

export const glacierPolicyApiGetPolicyOptions = (
  options: Options<GlacierPolicyApiGetPolicyData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetPolicy({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetPolicyQueryKey(options),
  });
};

export const glacierPolicyApiGetLatestTransactionSummaryQueryKey = (
  options: Options<GlacierPolicyApiGetLatestTransactionSummaryData>
) => [createQueryKey('glacierPolicyApiGetLatestTransactionSummary', options)];

export const glacierPolicyApiGetLatestTransactionSummaryOptions = (
  options: Options<GlacierPolicyApiGetLatestTransactionSummaryData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetLatestTransactionSummary({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetLatestTransactionSummaryQueryKey(options),
  });
};

export const glacierPolicyApiGetLatestTransactionLatestAttemptQueryKey = (
  options: Options<GlacierPolicyApiGetLatestTransactionLatestAttemptData>
) => [
  createQueryKey('glacierPolicyApiGetLatestTransactionLatestAttempt', options),
];

export const glacierPolicyApiGetLatestTransactionLatestAttemptOptions = (
  options: Options<GlacierPolicyApiGetLatestTransactionLatestAttemptData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetLatestTransactionLatestAttempt({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      glacierPolicyApiGetLatestTransactionLatestAttemptQueryKey(options),
  });
};

export const glacierPolicyApiValidatePolicyFieldsQueryKey = (
  options: Options<GlacierPolicyApiValidatePolicyFieldsData>
) => [createQueryKey('glacierPolicyApiValidatePolicyFields', options)];

export const glacierPolicyApiValidatePolicyFieldsOptions = (
  options: Options<GlacierPolicyApiValidatePolicyFieldsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiValidatePolicyFields({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiValidatePolicyFieldsQueryKey(options),
  });
};

export const glacierPolicyApiAssignAgentQueryKey = (
  options: Options<GlacierPolicyApiAssignAgentData>
) => [createQueryKey('glacierPolicyApiAssignAgent', options)];

export const glacierPolicyApiAssignAgentOptions = (
  options: Options<GlacierPolicyApiAssignAgentData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiAssignAgent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiAssignAgentQueryKey(options),
  });
};

export const glacierPolicyApiAssignAgentMutation = (
  options?: Partial<Options<GlacierPolicyApiAssignAgentData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiAssignAgentResponse,
    GlacierPolicyApiAssignAgentError,
    Options<GlacierPolicyApiAssignAgentData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiAssignAgent({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiAssignUnderwriterQueryKey = (
  options: Options<GlacierPolicyApiAssignUnderwriterData>
) => [createQueryKey('glacierPolicyApiAssignUnderwriter', options)];

export const glacierPolicyApiAssignUnderwriterOptions = (
  options: Options<GlacierPolicyApiAssignUnderwriterData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiAssignUnderwriter({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiAssignUnderwriterQueryKey(options),
  });
};

export const glacierPolicyApiAssignUnderwriterMutation = (
  options?: Partial<Options<GlacierPolicyApiAssignUnderwriterData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiAssignUnderwriterResponse,
    GlacierPolicyApiAssignUnderwriterError,
    Options<GlacierPolicyApiAssignUnderwriterData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiAssignUnderwriter({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiAssignQueryKey = (
  options: Options<GlacierPolicyApiAssignData>
) => [createQueryKey('glacierPolicyApiAssign', options)];

export const glacierPolicyApiAssignOptions = (
  options: Options<GlacierPolicyApiAssignData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiAssign({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiAssignQueryKey(options),
  });
};

export const glacierPolicyApiAssignMutation = (
  options?: Partial<Options<GlacierPolicyApiAssignData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiAssignResponse,
    GlacierPolicyApiAssignError,
    Options<GlacierPolicyApiAssignData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiAssign({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiAssignableQueryKey = (
  options: Options<GlacierPolicyApiAssignableData>
) => [createQueryKey('glacierPolicyApiAssignable', options)];

export const glacierPolicyApiAssignableOptions = (
  options: Options<GlacierPolicyApiAssignableData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiAssignable({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiAssignableQueryKey(options),
  });
};

export const glacierPolicyApiGetPolicyWithSummariesQueryKey = (
  options: Options<GlacierPolicyApiGetPolicyWithSummariesData>
) => [createQueryKey('glacierPolicyApiGetPolicyWithSummaries', options)];

export const glacierPolicyApiGetPolicyWithSummariesOptions = (
  options: Options<GlacierPolicyApiGetPolicyWithSummariesData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetPolicyWithSummaries({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetPolicyWithSummariesQueryKey(options),
  });
};

export const glacierPolicyApiGetPolicyPermissionsQueryKey = (
  options: Options<GlacierPolicyApiGetPolicyPermissionsData>
) => [createQueryKey('glacierPolicyApiGetPolicyPermissions', options)];

export const glacierPolicyApiGetPolicyPermissionsOptions = (
  options: Options<GlacierPolicyApiGetPolicyPermissionsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetPolicyPermissions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetPolicyPermissionsQueryKey(options),
  });
};

export const glacierPolicyApiDeclineTransactionQueryKey = (
  options: Options<GlacierPolicyApiDeclineTransactionData>
) => [createQueryKey('glacierPolicyApiDeclineTransaction', options)];

export const glacierPolicyApiDeclineTransactionOptions = (
  options: Options<GlacierPolicyApiDeclineTransactionData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiDeclineTransaction({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiDeclineTransactionQueryKey(options),
  });
};

export const glacierPolicyApiDeclineTransactionMutation = (
  options?: Partial<Options<GlacierPolicyApiDeclineTransactionData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDeclineTransactionResponse,
    GlacierPolicyApiDeclineTransactionError,
    Options<GlacierPolicyApiDeclineTransactionData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiDeclineTransaction({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiDiscardTransactionQueryKey = (
  options: Options<GlacierPolicyApiDiscardTransactionData>
) => [createQueryKey('glacierPolicyApiDiscardTransaction', options)];

export const glacierPolicyApiDiscardTransactionOptions = (
  options: Options<GlacierPolicyApiDiscardTransactionData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiDiscardTransaction({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiDiscardTransactionQueryKey(options),
  });
};

export const glacierPolicyApiDiscardTransactionMutation = (
  options?: Partial<Options<GlacierPolicyApiDiscardTransactionData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDiscardTransactionResponse,
    GlacierPolicyApiDiscardTransactionError,
    Options<GlacierPolicyApiDiscardTransactionData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiDiscardTransaction({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiReopenTransactionQueryKey = (
  options: Options<GlacierPolicyApiReopenTransactionData>
) => [createQueryKey('glacierPolicyApiReopenTransaction', options)];

export const glacierPolicyApiReopenTransactionOptions = (
  options: Options<GlacierPolicyApiReopenTransactionData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiReopenTransaction({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiReopenTransactionQueryKey(options),
  });
};

export const glacierPolicyApiReopenTransactionMutation = (
  options?: Partial<Options<GlacierPolicyApiReopenTransactionData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiReopenTransactionResponse,
    GlacierPolicyApiReopenTransactionError,
    Options<GlacierPolicyApiReopenTransactionData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiReopenTransaction({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiAddLocationQueryKey = (
  options: Options<GlacierPolicyApiAddLocationData>
) => [createQueryKey('glacierPolicyApiAddLocation', options)];

export const glacierPolicyApiAddLocationOptions = (
  options: Options<GlacierPolicyApiAddLocationData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiAddLocation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiAddLocationQueryKey(options),
  });
};

export const glacierPolicyApiAddLocationMutation = (
  options?: Partial<Options<GlacierPolicyApiAddLocationData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiAddLocationResponse,
    GlacierPolicyApiAddLocationError,
    Options<GlacierPolicyApiAddLocationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiAddLocation({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiUpdatePrimaryLocationQueryKey = (
  options: Options<GlacierPolicyApiUpdatePrimaryLocationData>
) => [createQueryKey('glacierPolicyApiUpdatePrimaryLocation', options)];

export const glacierPolicyApiUpdatePrimaryLocationOptions = (
  options: Options<GlacierPolicyApiUpdatePrimaryLocationData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiUpdatePrimaryLocation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiUpdatePrimaryLocationQueryKey(options),
  });
};

export const glacierPolicyApiUpdatePrimaryLocationMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdatePrimaryLocationData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdatePrimaryLocationResponse,
    GlacierPolicyApiUpdatePrimaryLocationError,
    Options<GlacierPolicyApiUpdatePrimaryLocationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiUpdatePrimaryLocation({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetLocationQueryKey = (
  options: Options<GlacierPolicyApiGetLocationData>
) => [createQueryKey('glacierPolicyApiGetLocation', options)];

export const glacierPolicyApiGetLocationOptions = (
  options: Options<GlacierPolicyApiGetLocationData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetLocation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetLocationQueryKey(options),
  });
};

export const glacierPolicyApiUpdateLocationMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateLocationData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateLocationResponse,
    GlacierPolicyApiUpdateLocationError,
    Options<GlacierPolicyApiUpdateLocationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiUpdateLocation({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiDeleteLocationMutation = (
  options?: Partial<Options<GlacierPolicyApiDeleteLocationData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDeleteLocationResponse,
    GlacierPolicyApiDeleteLocationError,
    Options<GlacierPolicyApiDeleteLocationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiDeleteLocation({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetDentistQueryKey = (
  options: Options<GlacierPolicyApiGetDentistData>
) => [createQueryKey('glacierPolicyApiGetDentist', options)];

export const glacierPolicyApiGetDentistOptions = (
  options: Options<GlacierPolicyApiGetDentistData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetDentist({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetDentistQueryKey(options),
  });
};

export const glacierPolicyApiAddDentistQueryKey = (
  options: Options<GlacierPolicyApiAddDentistData>
) => [createQueryKey('glacierPolicyApiAddDentist', options)];

export const glacierPolicyApiAddDentistOptions = (
  options: Options<GlacierPolicyApiAddDentistData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiAddDentist({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiAddDentistQueryKey(options),
  });
};

export const glacierPolicyApiAddDentistMutation = (
  options?: Partial<Options<GlacierPolicyApiAddDentistData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiAddDentistResponse,
    GlacierPolicyApiAddDentistError,
    Options<GlacierPolicyApiAddDentistData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiAddDentist({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiDeleteDentistMutation = (
  options?: Partial<Options<GlacierPolicyApiDeleteDentistData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDeleteDentistResponse,
    GlacierPolicyApiDeleteDentistError,
    Options<GlacierPolicyApiDeleteDentistData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiDeleteDentist({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiUpdateBasicDentistMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateBasicDentistData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateBasicDentistResponse,
    GlacierPolicyApiUpdateBasicDentistError,
    Options<GlacierPolicyApiUpdateBasicDentistData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiUpdateBasicDentist({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiUpdateDentistInformationMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateDentistInformationData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateDentistInformationResponse,
    GlacierPolicyApiUpdateDentistInformationError,
    Options<GlacierPolicyApiUpdateDentistInformationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiUpdateDentistInformation({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetDentistInformationQueryKey = (
  options: Options<GlacierPolicyApiGetDentistInformationData>
) => [createQueryKey('glacierPolicyApiGetDentistInformation', options)];

export const glacierPolicyApiGetDentistInformationOptions = (
  options: Options<GlacierPolicyApiGetDentistInformationData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetDentistInformation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetDentistInformationQueryKey(options),
  });
};

export const glacierPolicyApiUpdateDentistPricingMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateDentistPricingData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateDentistPricingResponse,
    GlacierPolicyApiUpdateDentistPricingError,
    Options<GlacierPolicyApiUpdateDentistPricingData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiUpdateDentistPricing({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetDentistPricingQueryKey = (
  options: Options<GlacierPolicyApiGetDentistPricingData>
) => [createQueryKey('glacierPolicyApiGetDentistPricing', options)];

export const glacierPolicyApiGetDentistPricingOptions = (
  options: Options<GlacierPolicyApiGetDentistPricingData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetDentistPricing({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetDentistPricingQueryKey(options),
  });
};

export const glacierPolicyApiUpdateDentistProceduresMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateDentistProceduresData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateDentistProceduresResponse,
    GlacierPolicyApiUpdateDentistProceduresError,
    Options<GlacierPolicyApiUpdateDentistProceduresData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiUpdateDentistProcedures({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetDentistProceduresQueryKey = (
  options: Options<GlacierPolicyApiGetDentistProceduresData>
) => [createQueryKey('glacierPolicyApiGetDentistProcedures', options)];

export const glacierPolicyApiGetDentistProceduresOptions = (
  options: Options<GlacierPolicyApiGetDentistProceduresData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetDentistProcedures({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetDentistProceduresQueryKey(options),
  });
};

export const glacierPolicyApiUpdatePlPracticeOwnerMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdatePlPracticeOwnerData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdatePlPracticeOwnerResponse,
    GlacierPolicyApiUpdatePlPracticeOwnerError,
    Options<GlacierPolicyApiUpdatePlPracticeOwnerData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiUpdatePlPracticeOwner({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetPracticeOwnersQueryKey = (
  options: Options<GlacierPolicyApiGetPracticeOwnersData>
) => [createQueryKey('glacierPolicyApiGetPracticeOwners', options)];

export const glacierPolicyApiGetPracticeOwnersOptions = (
  options: Options<GlacierPolicyApiGetPracticeOwnersData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetPracticeOwners({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetPracticeOwnersQueryKey(options),
  });
};

export const glacierPolicyApiUpdatePlCoverageMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdatePlCoverageData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdatePlCoverageResponse,
    GlacierPolicyApiUpdatePlCoverageError,
    Options<GlacierPolicyApiUpdatePlCoverageData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiUpdatePlCoverage({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetPlCoverageQueryKey = (
  options: Options<GlacierPolicyApiGetPlCoverageData>
) => [createQueryKey('glacierPolicyApiGetPlCoverage', options)];

export const glacierPolicyApiGetPlCoverageOptions = (
  options: Options<GlacierPolicyApiGetPlCoverageData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetPlCoverage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetPlCoverageQueryKey(options),
  });
};

export const glacierPolicyApiUpdatePolicyDetailsMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdatePolicyDetailsData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdatePolicyDetailsResponse,
    GlacierPolicyApiUpdatePolicyDetailsError,
    Options<GlacierPolicyApiUpdatePolicyDetailsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiUpdatePolicyDetails({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetPolicyDetailsQueryKey = (
  options: Options<GlacierPolicyApiGetPolicyDetailsData>
) => [createQueryKey('glacierPolicyApiGetPolicyDetails', options)];

export const glacierPolicyApiGetPolicyDetailsOptions = (
  options: Options<GlacierPolicyApiGetPolicyDetailsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetPolicyDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetPolicyDetailsQueryKey(options),
  });
};

export const glacierPolicyApiRefreshCommercialPropertyWithVeriskQueryKey = (
  options: Options<GlacierPolicyApiRefreshCommercialPropertyWithVeriskData>
) => [
  createQueryKey(
    'glacierPolicyApiRefreshCommercialPropertyWithVerisk',
    options
  ),
];

export const glacierPolicyApiRefreshCommercialPropertyWithVeriskOptions = (
  options: Options<GlacierPolicyApiRefreshCommercialPropertyWithVeriskData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await glacierPolicyApiRefreshCommercialPropertyWithVerisk({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      glacierPolicyApiRefreshCommercialPropertyWithVeriskQueryKey(options),
  });
};

export const glacierPolicyApiRefreshCommercialPropertyWithVeriskMutation = (
  options?: Partial<
    Options<GlacierPolicyApiRefreshCommercialPropertyWithVeriskData>
  >
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiRefreshCommercialPropertyWithVeriskResponse,
    GlacierPolicyApiRefreshCommercialPropertyWithVeriskError,
    Options<GlacierPolicyApiRefreshCommercialPropertyWithVeriskData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } =
        await glacierPolicyApiRefreshCommercialPropertyWithVerisk({
          ...options,
          ...localOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiRefreshCommercialPropertyWithCorelogicQueryKey = (
  options: Options<GlacierPolicyApiRefreshCommercialPropertyWithCorelogicData>
) => [
  createQueryKey(
    'glacierPolicyApiRefreshCommercialPropertyWithCorelogic',
    options
  ),
];

export const glacierPolicyApiRefreshCommercialPropertyWithCorelogicOptions = (
  options: Options<GlacierPolicyApiRefreshCommercialPropertyWithCorelogicData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await glacierPolicyApiRefreshCommercialPropertyWithCorelogic({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      glacierPolicyApiRefreshCommercialPropertyWithCorelogicQueryKey(options),
  });
};

export const glacierPolicyApiRefreshCommercialPropertyWithCorelogicMutation = (
  options?: Partial<
    Options<GlacierPolicyApiRefreshCommercialPropertyWithCorelogicData>
  >
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiRefreshCommercialPropertyWithCorelogicResponse,
    GlacierPolicyApiRefreshCommercialPropertyWithCorelogicError,
    Options<GlacierPolicyApiRefreshCommercialPropertyWithCorelogicData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } =
        await glacierPolicyApiRefreshCommercialPropertyWithCorelogic({
          ...options,
          ...localOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiAddCommercialPropertyCoverageQueryKey = (
  options: Options<GlacierPolicyApiAddCommercialPropertyCoverageData>
) => [createQueryKey('glacierPolicyApiAddCommercialPropertyCoverage', options)];

export const glacierPolicyApiAddCommercialPropertyCoverageOptions = (
  options: Options<GlacierPolicyApiAddCommercialPropertyCoverageData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiAddCommercialPropertyCoverage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiAddCommercialPropertyCoverageQueryKey(options),
  });
};

export const glacierPolicyApiAddCommercialPropertyCoverageMutation = (
  options?: Partial<Options<GlacierPolicyApiAddCommercialPropertyCoverageData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiAddCommercialPropertyCoverageResponse,
    GlacierPolicyApiAddCommercialPropertyCoverageError,
    Options<GlacierPolicyApiAddCommercialPropertyCoverageData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiAddCommercialPropertyCoverage({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiUpdateCommercialPropertyCoverageMutation = (
  options?: Partial<
    Options<GlacierPolicyApiUpdateCommercialPropertyCoverageData>
  >
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateCommercialPropertyCoverageResponse,
    GlacierPolicyApiUpdateCommercialPropertyCoverageError,
    Options<GlacierPolicyApiUpdateCommercialPropertyCoverageData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiUpdateCommercialPropertyCoverage({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiDeleteCommercialPropertyCoverageMutation = (
  options?: Partial<
    Options<GlacierPolicyApiDeleteCommercialPropertyCoverageData>
  >
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDeleteCommercialPropertyCoverageResponse,
    GlacierPolicyApiDeleteCommercialPropertyCoverageError,
    Options<GlacierPolicyApiDeleteCommercialPropertyCoverageData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiDeleteCommercialPropertyCoverage({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetCommercialPropertyLocationQueryKey = (
  options: Options<GlacierPolicyApiGetCommercialPropertyLocationData>
) => [createQueryKey('glacierPolicyApiGetCommercialPropertyLocation', options)];

export const glacierPolicyApiGetCommercialPropertyLocationOptions = (
  options: Options<GlacierPolicyApiGetCommercialPropertyLocationData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetCommercialPropertyLocation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetCommercialPropertyLocationQueryKey(options),
  });
};

export const glacierPolicyApiUpdateCpCoverageMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateCpCoverageData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateCpCoverageResponse,
    GlacierPolicyApiUpdateCpCoverageError,
    Options<GlacierPolicyApiUpdateCpCoverageData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiUpdateCpCoverage({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetCommercialPropertyCoverageQueryKey = (
  options: Options<GlacierPolicyApiGetCommercialPropertyCoverageData>
) => [createQueryKey('glacierPolicyApiGetCommercialPropertyCoverage', options)];

export const glacierPolicyApiGetCommercialPropertyCoverageOptions = (
  options: Options<GlacierPolicyApiGetCommercialPropertyCoverageData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetCommercialPropertyCoverage({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetCommercialPropertyCoverageQueryKey(options),
  });
};

export const glacierPolicyApiRatePolicyQueryKey = (
  options: Options<GlacierPolicyApiRatePolicyData>
) => [createQueryKey('glacierPolicyApiRatePolicy', options)];

export const glacierPolicyApiRatePolicyOptions = (
  options: Options<GlacierPolicyApiRatePolicyData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiRatePolicy({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiRatePolicyQueryKey(options),
  });
};

export const glacierPolicyApiRatePolicyMutation = (
  options?: Partial<Options<GlacierPolicyApiRatePolicyData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiRatePolicyResponse,
    GlacierPolicyApiRatePolicyError,
    Options<GlacierPolicyApiRatePolicyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiRatePolicy({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetFormulasQueryKey = (
  options: Options<GlacierPolicyApiGetFormulasData>
) => [createQueryKey('glacierPolicyApiGetFormulas', options)];

export const glacierPolicyApiGetFormulasOptions = (
  options: Options<GlacierPolicyApiGetFormulasData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetFormulas({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetFormulasQueryKey(options),
  });
};

export const glacierPolicyApiCreateOwnedEntitiesQueryKey = (
  options: Options<GlacierPolicyApiCreateOwnedEntitiesData>
) => [createQueryKey('glacierPolicyApiCreateOwnedEntities', options)];

export const glacierPolicyApiCreateOwnedEntitiesOptions = (
  options: Options<GlacierPolicyApiCreateOwnedEntitiesData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiCreateOwnedEntities({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiCreateOwnedEntitiesQueryKey(options),
  });
};

export const glacierPolicyApiCreateOwnedEntitiesMutation = (
  options?: Partial<Options<GlacierPolicyApiCreateOwnedEntitiesData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiCreateOwnedEntitiesResponse,
    GlacierPolicyApiCreateOwnedEntitiesError,
    Options<GlacierPolicyApiCreateOwnedEntitiesData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiCreateOwnedEntities({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetOwnedEntityQueryKey = (
  options: Options<GlacierPolicyApiGetOwnedEntityData>
) => [createQueryKey('glacierPolicyApiGetOwnedEntity', options)];

export const glacierPolicyApiGetOwnedEntityOptions = (
  options: Options<GlacierPolicyApiGetOwnedEntityData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetOwnedEntity({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetOwnedEntityQueryKey(options),
  });
};

export const glacierPolicyApiUpdatedOwnedEntityMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdatedOwnedEntityData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdatedOwnedEntityResponse,
    GlacierPolicyApiUpdatedOwnedEntityError,
    Options<GlacierPolicyApiUpdatedOwnedEntityData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiUpdatedOwnedEntity({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiDeleteOwnedEntityMutation = (
  options?: Partial<Options<GlacierPolicyApiDeleteOwnedEntityData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDeleteOwnedEntityResponse,
    GlacierPolicyApiDeleteOwnedEntityError,
    Options<GlacierPolicyApiDeleteOwnedEntityData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiDeleteOwnedEntity({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiUpdateGeneralLiabilityMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateGeneralLiabilityData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateGeneralLiabilityResponse,
    GlacierPolicyApiUpdateGeneralLiabilityError,
    Options<GlacierPolicyApiUpdateGeneralLiabilityData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiUpdateGeneralLiability({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiUpdateEmploymentPracticesLiabilityMutation = (
  options?: Partial<
    Options<GlacierPolicyApiUpdateEmploymentPracticesLiabilityData>
  >
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateEmploymentPracticesLiabilityResponse,
    GlacierPolicyApiUpdateEmploymentPracticesLiabilityError,
    Options<GlacierPolicyApiUpdateEmploymentPracticesLiabilityData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiUpdateEmploymentPracticesLiability(
        {
          ...options,
          ...localOptions,
          throwOnError: true,
        }
      );
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiUpdateErisaAndEmployeeBenefitsMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateErisaAndEmployeeBenefitsData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateErisaAndEmployeeBenefitsResponse,
    GlacierPolicyApiUpdateErisaAndEmployeeBenefitsError,
    Options<GlacierPolicyApiUpdateErisaAndEmployeeBenefitsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiUpdateErisaAndEmployeeBenefits({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiIssuePolicyQueryKey = (
  options: Options<GlacierPolicyApiIssuePolicyData>
) => [createQueryKey('glacierPolicyApiIssuePolicy', options)];

export const glacierPolicyApiIssuePolicyOptions = (
  options: Options<GlacierPolicyApiIssuePolicyData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiIssuePolicy({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiIssuePolicyQueryKey(options),
  });
};

export const glacierPolicyApiIssuePolicyMutation = (
  options?: Partial<Options<GlacierPolicyApiIssuePolicyData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiIssuePolicyResponse,
    GlacierPolicyApiIssuePolicyError,
    Options<GlacierPolicyApiIssuePolicyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiIssuePolicy({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiCreateMidtermTransactionQueryKey = (
  options: Options<GlacierPolicyApiCreateMidtermTransactionData>
) => [createQueryKey('glacierPolicyApiCreateMidtermTransaction', options)];

export const glacierPolicyApiCreateMidtermTransactionOptions = (
  options: Options<GlacierPolicyApiCreateMidtermTransactionData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiCreateMidtermTransaction({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiCreateMidtermTransactionQueryKey(options),
  });
};

export const glacierPolicyApiCreateMidtermTransactionMutation = (
  options?: Partial<Options<GlacierPolicyApiCreateMidtermTransactionData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiCreateMidtermTransactionResponse,
    GlacierPolicyApiCreateMidtermTransactionError,
    Options<GlacierPolicyApiCreateMidtermTransactionData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiCreateMidtermTransaction({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiSetReasonForChangeQueryKey = (
  options: Options<GlacierPolicyApiSetReasonForChangeData>
) => [createQueryKey('glacierPolicyApiSetReasonForChange', options)];

export const glacierPolicyApiSetReasonForChangeOptions = (
  options: Options<GlacierPolicyApiSetReasonForChangeData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiSetReasonForChange({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiSetReasonForChangeQueryKey(options),
  });
};

export const glacierPolicyApiSetReasonForChangeMutation = (
  options?: Partial<Options<GlacierPolicyApiSetReasonForChangeData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiSetReasonForChangeResponse,
    GlacierPolicyApiSetReasonForChangeError,
    Options<GlacierPolicyApiSetReasonForChangeData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiSetReasonForChange({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiPricePreviewMidtermChangeQueryKey = (
  options: Options<GlacierPolicyApiPricePreviewMidtermChangeData>
) => [createQueryKey('glacierPolicyApiPricePreviewMidtermChange', options)];

export const glacierPolicyApiPricePreviewMidtermChangeOptions = (
  options: Options<GlacierPolicyApiPricePreviewMidtermChangeData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiPricePreviewMidtermChange({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiPricePreviewMidtermChangeQueryKey(options),
  });
};

export const glacierPolicyApiGetAgentAuthorityQueryKey = (
  options: Options<GlacierPolicyApiGetAgentAuthorityData>
) => [createQueryKey('glacierPolicyApiGetAgentAuthority', options)];

export const glacierPolicyApiGetAgentAuthorityOptions = (
  options: Options<GlacierPolicyApiGetAgentAuthorityData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetAgentAuthority({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetAgentAuthorityQueryKey(options),
  });
};

export const glacierPolicyApiFinalizeMidtermChangeQueryKey = (
  options: Options<GlacierPolicyApiFinalizeMidtermChangeData>
) => [createQueryKey('glacierPolicyApiFinalizeMidtermChange', options)];

export const glacierPolicyApiFinalizeMidtermChangeOptions = (
  options: Options<GlacierPolicyApiFinalizeMidtermChangeData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiFinalizeMidtermChange({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiFinalizeMidtermChangeQueryKey(options),
  });
};

export const glacierPolicyApiFinalizeMidtermChangeMutation = (
  options?: Partial<Options<GlacierPolicyApiFinalizeMidtermChangeData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiFinalizeMidtermChangeResponse,
    GlacierPolicyApiFinalizeMidtermChangeError,
    Options<GlacierPolicyApiFinalizeMidtermChangeData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiFinalizeMidtermChange({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiCancelMidtermChangeQueryKey = (
  options: Options<GlacierPolicyApiCancelMidtermChangeData>
) => [createQueryKey('glacierPolicyApiCancelMidtermChange', options)];

export const glacierPolicyApiCancelMidtermChangeOptions = (
  options: Options<GlacierPolicyApiCancelMidtermChangeData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiCancelMidtermChange({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiCancelMidtermChangeQueryKey(options),
  });
};

export const glacierPolicyApiCancelMidtermChangeMutation = (
  options?: Partial<Options<GlacierPolicyApiCancelMidtermChangeData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiCancelMidtermChangeResponse,
    GlacierPolicyApiCancelMidtermChangeError,
    Options<GlacierPolicyApiCancelMidtermChangeData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiCancelMidtermChange({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiRevertTransactionQueryKey = (
  options: Options<GlacierPolicyApiRevertTransactionData>
) => [createQueryKey('glacierPolicyApiRevertTransaction', options)];

export const glacierPolicyApiRevertTransactionOptions = (
  options: Options<GlacierPolicyApiRevertTransactionData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiRevertTransaction({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiRevertTransactionQueryKey(options),
  });
};

export const glacierPolicyApiRevertTransactionMutation = (
  options?: Partial<Options<GlacierPolicyApiRevertTransactionData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiRevertTransactionResponse,
    GlacierPolicyApiRevertTransactionError,
    Options<GlacierPolicyApiRevertTransactionData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiRevertTransaction({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiUpdateDentistUnderwritingQuestionsMutation = (
  options?: Partial<
    Options<GlacierPolicyApiUpdateDentistUnderwritingQuestionsData>
  >
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateDentistUnderwritingQuestionsResponse,
    GlacierPolicyApiUpdateDentistUnderwritingQuestionsError,
    Options<GlacierPolicyApiUpdateDentistUnderwritingQuestionsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiUpdateDentistUnderwritingQuestions(
        {
          ...options,
          ...localOptions,
          throwOnError: true,
        }
      );
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiPremiumStatementQueryKey = (
  options: Options<GlacierPolicyApiPremiumStatementData>
) => [createQueryKey('glacierPolicyApiPremiumStatement', options)];

export const glacierPolicyApiPremiumStatementOptions = (
  options: Options<GlacierPolicyApiPremiumStatementData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiPremiumStatement({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiPremiumStatementQueryKey(options),
  });
};

export const glacierPolicyApiPremiumStatementMutation = (
  options?: Partial<Options<GlacierPolicyApiPremiumStatementData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiPremiumStatementResponse,
    GlacierPolicyApiPremiumStatementError,
    Options<GlacierPolicyApiPremiumStatementData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiPremiumStatement({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiGetSpecialFormsQueryKey = (
  options: Options<GlacierPolicyApiGetSpecialFormsData>
) => [createQueryKey('glacierPolicyApiGetSpecialForms', options)];

export const glacierPolicyApiGetSpecialFormsOptions = (
  options: Options<GlacierPolicyApiGetSpecialFormsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetSpecialForms({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetSpecialFormsQueryKey(options),
  });
};

export const glacierPolicyApiGetSpecialFormsMutation = (
  options?: Partial<Options<GlacierPolicyApiGetSpecialFormsData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiGetSpecialFormsResponse,
    GlacierPolicyApiGetSpecialFormsError,
    Options<GlacierPolicyApiGetSpecialFormsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiGetSpecialForms({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiConditionalRenewalNoticeQueryKey = (
  options: Options<GlacierPolicyApiConditionalRenewalNoticeData>
) => [createQueryKey('glacierPolicyApiConditionalRenewalNotice', options)];

export const glacierPolicyApiConditionalRenewalNoticeOptions = (
  options: Options<GlacierPolicyApiConditionalRenewalNoticeData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiConditionalRenewalNotice({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiConditionalRenewalNoticeQueryKey(options),
  });
};

export const glacierPolicyApiConditionalRenewalNoticeMutation = (
  options?: Partial<Options<GlacierPolicyApiConditionalRenewalNoticeData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiConditionalRenewalNoticeResponse,
    GlacierPolicyApiConditionalRenewalNoticeError,
    Options<GlacierPolicyApiConditionalRenewalNoticeData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiConditionalRenewalNotice({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiDownloadRatingWorksheetsQueryKey = (
  options: Options<GlacierPolicyApiDownloadRatingWorksheetsData>
) => [createQueryKey('glacierPolicyApiDownloadRatingWorksheets', options)];

export const glacierPolicyApiDownloadRatingWorksheetsOptions = (
  options: Options<GlacierPolicyApiDownloadRatingWorksheetsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiDownloadRatingWorksheets({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiDownloadRatingWorksheetsQueryKey(options),
  });
};

export const glacierPolicyApiDownloadRatingWorksheetsMutation = (
  options?: Partial<Options<GlacierPolicyApiDownloadRatingWorksheetsData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDownloadRatingWorksheetsResponse,
    GlacierPolicyApiDownloadRatingWorksheetsError,
    Options<GlacierPolicyApiDownloadRatingWorksheetsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiDownloadRatingWorksheets({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiPremiumRenewalNoticeQueryKey = (
  options: Options<GlacierPolicyApiPremiumRenewalNoticeData>
) => [createQueryKey('glacierPolicyApiPremiumRenewalNotice', options)];

export const glacierPolicyApiPremiumRenewalNoticeOptions = (
  options: Options<GlacierPolicyApiPremiumRenewalNoticeData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiPremiumRenewalNotice({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiPremiumRenewalNoticeQueryKey(options),
  });
};

export const glacierPolicyApiPremiumRenewalNoticeMutation = (
  options?: Partial<Options<GlacierPolicyApiPremiumRenewalNoticeData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiPremiumRenewalNoticeResponse,
    GlacierPolicyApiPremiumRenewalNoticeError,
    Options<GlacierPolicyApiPremiumRenewalNoticeData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiPremiumRenewalNotice({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiDownloadLookerDashboardPdfQueryKey = (
  options: Options<GlacierPolicyApiDownloadLookerDashboardPdfData>
) => [createQueryKey('glacierPolicyApiDownloadLookerDashboardPdf', options)];

export const glacierPolicyApiDownloadLookerDashboardPdfOptions = (
  options: Options<GlacierPolicyApiDownloadLookerDashboardPdfData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiDownloadLookerDashboardPdf({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiDownloadLookerDashboardPdfQueryKey(options),
  });
};

export const glacierPolicyApiDownloadLookerDashboardPdfMutation = (
  options?: Partial<Options<GlacierPolicyApiDownloadLookerDashboardPdfData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDownloadLookerDashboardPdfResponse,
    GlacierPolicyApiDownloadLookerDashboardPdfError,
    Options<GlacierPolicyApiDownloadLookerDashboardPdfData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiDownloadLookerDashboardPdf({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiDownloadLookerDashboardCsvQueryKey = (
  options: Options<GlacierPolicyApiDownloadLookerDashboardCsvData>
) => [createQueryKey('glacierPolicyApiDownloadLookerDashboardCsv', options)];

export const glacierPolicyApiDownloadLookerDashboardCsvOptions = (
  options: Options<GlacierPolicyApiDownloadLookerDashboardCsvData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiDownloadLookerDashboardCsv({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiDownloadLookerDashboardCsvQueryKey(options),
  });
};

export const glacierPolicyApiDownloadLookerDashboardCsvMutation = (
  options?: Partial<Options<GlacierPolicyApiDownloadLookerDashboardCsvData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDownloadLookerDashboardCsvResponse,
    GlacierPolicyApiDownloadLookerDashboardCsvError,
    Options<GlacierPolicyApiDownloadLookerDashboardCsvData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiDownloadLookerDashboardCsv({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiSpecimenPreviewQueryKey = (
  options: Options<GlacierPolicyApiSpecimenPreviewData>
) => [createQueryKey('glacierPolicyApiSpecimenPreview', options)];

export const glacierPolicyApiSpecimenPreviewOptions = (
  options: Options<GlacierPolicyApiSpecimenPreviewData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiSpecimenPreview({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiSpecimenPreviewQueryKey(options),
  });
};

export const glacierPolicyApiListDocumentsQueryKey = (
  options: Options<GlacierPolicyApiListDocumentsData>
) => [createQueryKey('glacierPolicyApiListDocuments', options)];

export const glacierPolicyApiListDocumentsOptions = (
  options: Options<GlacierPolicyApiListDocumentsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiListDocuments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiListDocumentsQueryKey(options),
  });
};

export const glacierPolicyApiUploadDocumentQueryKey = (
  options: Options<GlacierPolicyApiUploadDocumentData>
) => [createQueryKey('glacierPolicyApiUploadDocument', options)];

export const glacierPolicyApiUploadDocumentOptions = (
  options: Options<GlacierPolicyApiUploadDocumentData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiUploadDocument({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiUploadDocumentQueryKey(options),
  });
};

export const glacierPolicyApiUploadDocumentMutation = (
  options?: Partial<Options<GlacierPolicyApiUploadDocumentData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUploadDocumentResponse,
    GlacierPolicyApiUploadDocumentError,
    Options<GlacierPolicyApiUploadDocumentData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiUploadDocument({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiDetachDocumentMutation = (
  options?: Partial<Options<GlacierPolicyApiDetachDocumentData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDetachDocumentResponse,
    GlacierPolicyApiDetachDocumentError,
    Options<GlacierPolicyApiDetachDocumentData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiDetachDocument({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiUpdateDocumentMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateDocumentData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateDocumentResponse,
    GlacierPolicyApiUpdateDocumentError,
    Options<GlacierPolicyApiUpdateDocumentData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiUpdateDocument({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const documentIsReadyQueryKey = (
  options: Options<DocumentIsReadyData>
) => [createQueryKey('documentIsReady', options)];

export const documentIsReadyOptions = (
  options: Options<DocumentIsReadyData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await documentIsReady({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: documentIsReadyQueryKey(options),
  });
};

export const glacierPolicyApiDownloadDocumentQueryKey = (
  options: Options<GlacierPolicyApiDownloadDocumentData>
) => [createQueryKey('glacierPolicyApiDownloadDocument', options)];

export const glacierPolicyApiDownloadDocumentOptions = (
  options: Options<GlacierPolicyApiDownloadDocumentData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiDownloadDocument({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiDownloadDocumentQueryKey(options),
  });
};

export const glacierPolicyApiRegenerateDocumentQueryKey = (
  options: Options<GlacierPolicyApiRegenerateDocumentData>
) => [createQueryKey('glacierPolicyApiRegenerateDocument', options)];

export const glacierPolicyApiRegenerateDocumentOptions = (
  options: Options<GlacierPolicyApiRegenerateDocumentData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiRegenerateDocument({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiRegenerateDocumentQueryKey(options),
  });
};

export const glacierPolicyApiRegenerateDocumentMutation = (
  options?: Partial<Options<GlacierPolicyApiRegenerateDocumentData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiRegenerateDocumentResponse,
    GlacierPolicyApiRegenerateDocumentError,
    Options<GlacierPolicyApiRegenerateDocumentData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiRegenerateDocument({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiCommitTransactionTestQueryKey = (
  options: Options<GlacierPolicyApiCommitTransactionTestData>
) => [createQueryKey('glacierPolicyApiCommitTransactionTest', options)];

export const glacierPolicyApiCommitTransactionTestOptions = (
  options: Options<GlacierPolicyApiCommitTransactionTestData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiCommitTransactionTest({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiCommitTransactionTestQueryKey(options),
  });
};

export const glacierPolicyApiCommitTransactionTestMutation = (
  options?: Partial<Options<GlacierPolicyApiCommitTransactionTestData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiCommitTransactionTestResponse,
    GlacierPolicyApiCommitTransactionTestError,
    Options<GlacierPolicyApiCommitTransactionTestData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiCommitTransactionTest({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiListUnderwriterNotesQueryKey = (
  options: Options<GlacierPolicyApiListUnderwriterNotesData>
) => [createQueryKey('glacierPolicyApiListUnderwriterNotes', options)];

export const glacierPolicyApiListUnderwriterNotesOptions = (
  options: Options<GlacierPolicyApiListUnderwriterNotesData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiListUnderwriterNotes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiListUnderwriterNotesQueryKey(options),
  });
};

export const glacierPolicyApiCreateUnderwriterNotesQueryKey = (
  options: Options<GlacierPolicyApiCreateUnderwriterNotesData>
) => [createQueryKey('glacierPolicyApiCreateUnderwriterNotes', options)];

export const glacierPolicyApiCreateUnderwriterNotesOptions = (
  options: Options<GlacierPolicyApiCreateUnderwriterNotesData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiCreateUnderwriterNotes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiCreateUnderwriterNotesQueryKey(options),
  });
};

export const glacierPolicyApiCreateUnderwriterNotesMutation = (
  options?: Partial<Options<GlacierPolicyApiCreateUnderwriterNotesData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiCreateUnderwriterNotesResponse,
    GlacierPolicyApiCreateUnderwriterNotesError,
    Options<GlacierPolicyApiCreateUnderwriterNotesData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiCreateUnderwriterNotes({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiUpdateUnderwriterNotesMutation = (
  options?: Partial<Options<GlacierPolicyApiUpdateUnderwriterNotesData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiUpdateUnderwriterNotesResponse,
    GlacierPolicyApiUpdateUnderwriterNotesError,
    Options<GlacierPolicyApiUpdateUnderwriterNotesData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiUpdateUnderwriterNotes({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiDeleteUnderwriterNotesMutation = (
  options?: Partial<Options<GlacierPolicyApiDeleteUnderwriterNotesData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiDeleteUnderwriterNotesResponse,
    GlacierPolicyApiDeleteUnderwriterNotesError,
    Options<GlacierPolicyApiDeleteUnderwriterNotesData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiDeleteUnderwriterNotes({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiReopenUnlockedAccountQueryKey = (
  options: Options<GlacierPolicyApiReopenUnlockedAccountData>
) => [createQueryKey('glacierPolicyApiReopenUnlockedAccount', options)];

export const glacierPolicyApiReopenUnlockedAccountOptions = (
  options: Options<GlacierPolicyApiReopenUnlockedAccountData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiReopenUnlockedAccount({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiReopenUnlockedAccountQueryKey(options),
  });
};

export const glacierPolicyApiReopenUnlockedAccountMutation = (
  options?: Partial<Options<GlacierPolicyApiReopenUnlockedAccountData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiReopenUnlockedAccountResponse,
    GlacierPolicyApiReopenUnlockedAccountError,
    Options<GlacierPolicyApiReopenUnlockedAccountData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiReopenUnlockedAccount({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiCreatePolicyPendingCancellationTransactionQueryKey =
  (
    options: Options<GlacierPolicyApiCreatePolicyPendingCancellationTransactionData>
  ) => [
    createQueryKey(
      'glacierPolicyApiCreatePolicyPendingCancellationTransaction',
      options
    ),
  ];

export const glacierPolicyApiCreatePolicyPendingCancellationTransactionOptions =
  (
    options: Options<GlacierPolicyApiCreatePolicyPendingCancellationTransactionData>
  ) => {
    return queryOptions({
      queryFn: async ({ queryKey, signal }) => {
        const { data } =
          await glacierPolicyApiCreatePolicyPendingCancellationTransaction({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true,
          });
        return data;
      },
      queryKey:
        glacierPolicyApiCreatePolicyPendingCancellationTransactionQueryKey(
          options
        ),
    });
  };

export const glacierPolicyApiCreatePolicyPendingCancellationTransactionMutation =
  (
    options?: Partial<
      Options<GlacierPolicyApiCreatePolicyPendingCancellationTransactionData>
    >
  ) => {
    const mutationOptions: UseMutationOptions<
      GlacierPolicyApiCreatePolicyPendingCancellationTransactionResponse,
      GlacierPolicyApiCreatePolicyPendingCancellationTransactionError,
      Options<GlacierPolicyApiCreatePolicyPendingCancellationTransactionData>
    > = {
      mutationFn: async (localOptions) => {
        const { data } =
          await glacierPolicyApiCreatePolicyPendingCancellationTransaction({
            ...options,
            ...localOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

export const glacierPolicyApiListObjectSummariesQueryKey = (
  options: Options<GlacierPolicyApiListObjectSummariesData>
) => [createQueryKey('glacierPolicyApiListObjectSummaries', options)];

export const glacierPolicyApiListObjectSummariesOptions = (
  options: Options<GlacierPolicyApiListObjectSummariesData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiListObjectSummaries({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiListObjectSummariesQueryKey(options),
  });
};

export const glacierPolicyApiGetObjectDetailsQueryKey = (
  options: Options<GlacierPolicyApiGetObjectDetailsData>
) => [createQueryKey('glacierPolicyApiGetObjectDetails', options)];

export const glacierPolicyApiGetObjectDetailsOptions = (
  options: Options<GlacierPolicyApiGetObjectDetailsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetObjectDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetObjectDetailsQueryKey(options),
  });
};

export const glacierPolicyApiReferPolicyQueryKey = (
  options: Options<GlacierPolicyApiReferPolicyData>
) => [createQueryKey('glacierPolicyApiReferPolicy', options)];

export const glacierPolicyApiReferPolicyOptions = (
  options: Options<GlacierPolicyApiReferPolicyData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiReferPolicy({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiReferPolicyQueryKey(options),
  });
};

export const glacierPolicyApiReferPolicyMutation = (
  options?: Partial<Options<GlacierPolicyApiReferPolicyData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyApiReferPolicyResponse,
    GlacierPolicyApiReferPolicyError,
    Options<GlacierPolicyApiReferPolicyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyApiReferPolicy({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyApiListTransactionsQueryKey = (
  options: Options<GlacierPolicyApiListTransactionsData>
) => [createQueryKey('glacierPolicyApiListTransactions', options)];

export const glacierPolicyApiListTransactionsOptions = (
  options: Options<GlacierPolicyApiListTransactionsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiListTransactions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiListTransactionsQueryKey(options),
  });
};

export const glacierPolicyApiGetTransactionDetailQueryKey = (
  options: Options<GlacierPolicyApiGetTransactionDetailData>
) => [createQueryKey('glacierPolicyApiGetTransactionDetail', options)];

export const glacierPolicyApiGetTransactionDetailOptions = (
  options: Options<GlacierPolicyApiGetTransactionDetailData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyApiGetTransactionDetail({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyApiGetTransactionDetailQueryKey(options),
  });
};

export const glacierPolicyFormsApiPolicyLevelAttachedEndorsementsQueryKey = (
  options: Options<GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsData>
) => [
  createQueryKey(
    'glacierPolicyFormsApiPolicyLevelAttachedEndorsements',
    options
  ),
];

export const glacierPolicyFormsApiPolicyLevelAttachedEndorsementsOptions = (
  options: Options<GlacierPolicyFormsApiPolicyLevelAttachedEndorsementsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await glacierPolicyFormsApiPolicyLevelAttachedEndorsements({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      glacierPolicyFormsApiPolicyLevelAttachedEndorsementsQueryKey(options),
  });
};

export const glacierPolicyFormsApiAttachFormToPolicyQueryKey = (
  options: Options<GlacierPolicyFormsApiAttachFormToPolicyData>
) => [createQueryKey('glacierPolicyFormsApiAttachFormToPolicy', options)];

export const glacierPolicyFormsApiAttachFormToPolicyOptions = (
  options: Options<GlacierPolicyFormsApiAttachFormToPolicyData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiAttachFormToPolicy({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiAttachFormToPolicyQueryKey(options),
  });
};

export const glacierPolicyFormsApiAttachFormToPolicyMutation = (
  options?: Partial<Options<GlacierPolicyFormsApiAttachFormToPolicyData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyFormsApiAttachFormToPolicyResponse,
    GlacierPolicyFormsApiAttachFormToPolicyError,
    Options<GlacierPolicyFormsApiAttachFormToPolicyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyFormsApiAttachFormToPolicy({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyFormsApiDetachFormFromPolicyQueryKey = (
  options: Options<GlacierPolicyFormsApiDetachFormFromPolicyData>
) => [createQueryKey('glacierPolicyFormsApiDetachFormFromPolicy', options)];

export const glacierPolicyFormsApiDetachFormFromPolicyOptions = (
  options: Options<GlacierPolicyFormsApiDetachFormFromPolicyData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiDetachFormFromPolicy({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiDetachFormFromPolicyQueryKey(options),
  });
};

export const glacierPolicyFormsApiDetachFormFromPolicyMutation = (
  options?: Partial<Options<GlacierPolicyFormsApiDetachFormFromPolicyData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyFormsApiDetachFormFromPolicyResponse,
    GlacierPolicyFormsApiDetachFormFromPolicyError,
    Options<GlacierPolicyFormsApiDetachFormFromPolicyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyFormsApiDetachFormFromPolicy({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyFormsApiGetAvailableEndorsementsQueryKey = (
  options: Options<GlacierPolicyFormsApiGetAvailableEndorsementsData>
) => [createQueryKey('glacierPolicyFormsApiGetAvailableEndorsements', options)];

export const glacierPolicyFormsApiGetAvailableEndorsementsOptions = (
  options: Options<GlacierPolicyFormsApiGetAvailableEndorsementsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiGetAvailableEndorsements({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiGetAvailableEndorsementsQueryKey(options),
  });
};

export const glacierPolicyFormsApiAttachFormToDentistQueryKey = (
  options: Options<GlacierPolicyFormsApiAttachFormToDentistData>
) => [createQueryKey('glacierPolicyFormsApiAttachFormToDentist', options)];

export const glacierPolicyFormsApiAttachFormToDentistOptions = (
  options: Options<GlacierPolicyFormsApiAttachFormToDentistData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiAttachFormToDentist({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiAttachFormToDentistQueryKey(options),
  });
};

export const glacierPolicyFormsApiAttachFormToDentistMutation = (
  options?: Partial<Options<GlacierPolicyFormsApiAttachFormToDentistData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyFormsApiAttachFormToDentistResponse,
    GlacierPolicyFormsApiAttachFormToDentistError,
    Options<GlacierPolicyFormsApiAttachFormToDentistData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyFormsApiAttachFormToDentist({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyFormsApiDetachFormFromDentistQueryKey = (
  options: Options<GlacierPolicyFormsApiDetachFormFromDentistData>
) => [createQueryKey('glacierPolicyFormsApiDetachFormFromDentist', options)];

export const glacierPolicyFormsApiDetachFormFromDentistOptions = (
  options: Options<GlacierPolicyFormsApiDetachFormFromDentistData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiDetachFormFromDentist({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiDetachFormFromDentistQueryKey(options),
  });
};

export const glacierPolicyFormsApiDetachFormFromDentistMutation = (
  options?: Partial<Options<GlacierPolicyFormsApiDetachFormFromDentistData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyFormsApiDetachFormFromDentistResponse,
    GlacierPolicyFormsApiDetachFormFromDentistError,
    Options<GlacierPolicyFormsApiDetachFormFromDentistData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyFormsApiDetachFormFromDentist({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyFormsApiGetDentistAttachedFormsQueryKey = (
  options: Options<GlacierPolicyFormsApiGetDentistAttachedFormsData>
) => [createQueryKey('glacierPolicyFormsApiGetDentistAttachedForms', options)];

export const glacierPolicyFormsApiGetDentistAttachedFormsOptions = (
  options: Options<GlacierPolicyFormsApiGetDentistAttachedFormsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiGetDentistAttachedForms({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiGetDentistAttachedFormsQueryKey(options),
  });
};

export const glacierPolicyFormsApiGetDentistAvailableEndorsementsQueryKey = (
  options: Options<GlacierPolicyFormsApiGetDentistAvailableEndorsementsData>
) => [
  createQueryKey(
    'glacierPolicyFormsApiGetDentistAvailableEndorsements',
    options
  ),
];

export const glacierPolicyFormsApiGetDentistAvailableEndorsementsOptions = (
  options: Options<GlacierPolicyFormsApiGetDentistAvailableEndorsementsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await glacierPolicyFormsApiGetDentistAvailableEndorsements({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      glacierPolicyFormsApiGetDentistAvailableEndorsementsQueryKey(options),
  });
};

export const glacierPolicyFormsApiAttachFormToLocationQueryKey = (
  options: Options<GlacierPolicyFormsApiAttachFormToLocationData>
) => [createQueryKey('glacierPolicyFormsApiAttachFormToLocation', options)];

export const glacierPolicyFormsApiAttachFormToLocationOptions = (
  options: Options<GlacierPolicyFormsApiAttachFormToLocationData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiAttachFormToLocation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiAttachFormToLocationQueryKey(options),
  });
};

export const glacierPolicyFormsApiAttachFormToLocationMutation = (
  options?: Partial<Options<GlacierPolicyFormsApiAttachFormToLocationData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyFormsApiAttachFormToLocationResponse,
    GlacierPolicyFormsApiAttachFormToLocationError,
    Options<GlacierPolicyFormsApiAttachFormToLocationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyFormsApiAttachFormToLocation({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyFormsApiDetachFormFromLocationQueryKey = (
  options: Options<GlacierPolicyFormsApiDetachFormFromLocationData>
) => [createQueryKey('glacierPolicyFormsApiDetachFormFromLocation', options)];

export const glacierPolicyFormsApiDetachFormFromLocationOptions = (
  options: Options<GlacierPolicyFormsApiDetachFormFromLocationData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiDetachFormFromLocation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiDetachFormFromLocationQueryKey(options),
  });
};

export const glacierPolicyFormsApiDetachFormFromLocationMutation = (
  options?: Partial<Options<GlacierPolicyFormsApiDetachFormFromLocationData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyFormsApiDetachFormFromLocationResponse,
    GlacierPolicyFormsApiDetachFormFromLocationError,
    Options<GlacierPolicyFormsApiDetachFormFromLocationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyFormsApiDetachFormFromLocation({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyFormsApiGetLocationAttachedFormsQueryKey = (
  options: Options<GlacierPolicyFormsApiGetLocationAttachedFormsData>
) => [createQueryKey('glacierPolicyFormsApiGetLocationAttachedForms', options)];

export const glacierPolicyFormsApiGetLocationAttachedFormsOptions = (
  options: Options<GlacierPolicyFormsApiGetLocationAttachedFormsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiGetLocationAttachedForms({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiGetLocationAttachedFormsQueryKey(options),
  });
};

export const glacierPolicyFormsApiGetLocationAvailableEndorsementsQueryKey = (
  options: Options<GlacierPolicyFormsApiGetLocationAvailableEndorsementsData>
) => [
  createQueryKey(
    'glacierPolicyFormsApiGetLocationAvailableEndorsements',
    options
  ),
];

export const glacierPolicyFormsApiGetLocationAvailableEndorsementsOptions = (
  options: Options<GlacierPolicyFormsApiGetLocationAvailableEndorsementsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await glacierPolicyFormsApiGetLocationAvailableEndorsements({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      glacierPolicyFormsApiGetLocationAvailableEndorsementsQueryKey(options),
  });
};

export const glacierPolicyFormsApiAttachFormToEntityQueryKey = (
  options: Options<GlacierPolicyFormsApiAttachFormToEntityData>
) => [createQueryKey('glacierPolicyFormsApiAttachFormToEntity', options)];

export const glacierPolicyFormsApiAttachFormToEntityOptions = (
  options: Options<GlacierPolicyFormsApiAttachFormToEntityData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiAttachFormToEntity({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiAttachFormToEntityQueryKey(options),
  });
};

export const glacierPolicyFormsApiAttachFormToEntityMutation = (
  options?: Partial<Options<GlacierPolicyFormsApiAttachFormToEntityData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyFormsApiAttachFormToEntityResponse,
    GlacierPolicyFormsApiAttachFormToEntityError,
    Options<GlacierPolicyFormsApiAttachFormToEntityData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyFormsApiAttachFormToEntity({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyFormsApiDetachFormFromEntityQueryKey = (
  options: Options<GlacierPolicyFormsApiDetachFormFromEntityData>
) => [createQueryKey('glacierPolicyFormsApiDetachFormFromEntity', options)];

export const glacierPolicyFormsApiDetachFormFromEntityOptions = (
  options: Options<GlacierPolicyFormsApiDetachFormFromEntityData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiDetachFormFromEntity({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiDetachFormFromEntityQueryKey(options),
  });
};

export const glacierPolicyFormsApiDetachFormFromEntityMutation = (
  options?: Partial<Options<GlacierPolicyFormsApiDetachFormFromEntityData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyFormsApiDetachFormFromEntityResponse,
    GlacierPolicyFormsApiDetachFormFromEntityError,
    Options<GlacierPolicyFormsApiDetachFormFromEntityData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyFormsApiDetachFormFromEntity({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyFormsApiGetEntityAttachedFormsQueryKey = (
  options: Options<GlacierPolicyFormsApiGetEntityAttachedFormsData>
) => [createQueryKey('glacierPolicyFormsApiGetEntityAttachedForms', options)];

export const glacierPolicyFormsApiGetEntityAttachedFormsOptions = (
  options: Options<GlacierPolicyFormsApiGetEntityAttachedFormsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiGetEntityAttachedForms({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiGetEntityAttachedFormsQueryKey(options),
  });
};

export const glacierPolicyFormsApiGetEntityAvailableEndorsementsQueryKey = (
  options: Options<GlacierPolicyFormsApiGetEntityAvailableEndorsementsData>
) => [
  createQueryKey(
    'glacierPolicyFormsApiGetEntityAvailableEndorsements',
    options
  ),
];

export const glacierPolicyFormsApiGetEntityAvailableEndorsementsOptions = (
  options: Options<GlacierPolicyFormsApiGetEntityAvailableEndorsementsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await glacierPolicyFormsApiGetEntityAvailableEndorsements({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      glacierPolicyFormsApiGetEntityAvailableEndorsementsQueryKey(options),
  });
};

export const glacierPolicyFormsApiRenderFormQueryKey = (
  options: Options<GlacierPolicyFormsApiRenderFormData>
) => [createQueryKey('glacierPolicyFormsApiRenderForm', options)];

export const glacierPolicyFormsApiRenderFormOptions = (
  options: Options<GlacierPolicyFormsApiRenderFormData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiRenderForm({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiRenderFormQueryKey(options),
  });
};

export const glacierPolicyFormsApiRenderFormMutation = (
  options?: Partial<Options<GlacierPolicyFormsApiRenderFormData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyFormsApiRenderFormResponse,
    GlacierPolicyFormsApiRenderFormError,
    Options<GlacierPolicyFormsApiRenderFormData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyFormsApiRenderForm({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyFormsApiGetQuestionsByPolicyQueryKey = (
  options: Options<GlacierPolicyFormsApiGetQuestionsByPolicyData>
) => [createQueryKey('glacierPolicyFormsApiGetQuestionsByPolicy', options)];

export const glacierPolicyFormsApiGetQuestionsByPolicyOptions = (
  options: Options<GlacierPolicyFormsApiGetQuestionsByPolicyData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiGetQuestionsByPolicy({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiGetQuestionsByPolicyQueryKey(options),
  });
};

export const glacierPolicyFormsApiPostSaveQuestionsAnswersPolicyQueryKey = (
  options: Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyData>
) => [
  createQueryKey(
    'glacierPolicyFormsApiPostSaveQuestionsAnswersPolicy',
    options
  ),
];

export const glacierPolicyFormsApiPostSaveQuestionsAnswersPolicyOptions = (
  options: Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await glacierPolicyFormsApiPostSaveQuestionsAnswersPolicy({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      glacierPolicyFormsApiPostSaveQuestionsAnswersPolicyQueryKey(options),
  });
};

export const glacierPolicyFormsApiPostSaveQuestionsAnswersPolicyMutation = (
  options?: Partial<
    Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyData>
  >
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyResponse,
    GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyError,
    Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersPolicyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } =
        await glacierPolicyFormsApiPostSaveQuestionsAnswersPolicy({
          ...options,
          ...localOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyFormsApiGetQuestionsByDentistQueryKey = (
  options: Options<GlacierPolicyFormsApiGetQuestionsByDentistData>
) => [createQueryKey('glacierPolicyFormsApiGetQuestionsByDentist', options)];

export const glacierPolicyFormsApiGetQuestionsByDentistOptions = (
  options: Options<GlacierPolicyFormsApiGetQuestionsByDentistData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiGetQuestionsByDentist({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiGetQuestionsByDentistQueryKey(options),
  });
};

export const glacierPolicyFormsApiPostSaveQuestionsAnswersDentistQueryKey = (
  options: Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistData>
) => [
  createQueryKey(
    'glacierPolicyFormsApiPostSaveQuestionsAnswersDentist',
    options
  ),
];

export const glacierPolicyFormsApiPostSaveQuestionsAnswersDentistOptions = (
  options: Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await glacierPolicyFormsApiPostSaveQuestionsAnswersDentist({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      glacierPolicyFormsApiPostSaveQuestionsAnswersDentistQueryKey(options),
  });
};

export const glacierPolicyFormsApiPostSaveQuestionsAnswersDentistMutation = (
  options?: Partial<
    Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistData>
  >
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistResponse,
    GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistError,
    Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersDentistData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } =
        await glacierPolicyFormsApiPostSaveQuestionsAnswersDentist({
          ...options,
          ...localOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyFormsApiGetQuestionsByLocationQueryKey = (
  options: Options<GlacierPolicyFormsApiGetQuestionsByLocationData>
) => [createQueryKey('glacierPolicyFormsApiGetQuestionsByLocation', options)];

export const glacierPolicyFormsApiGetQuestionsByLocationOptions = (
  options: Options<GlacierPolicyFormsApiGetQuestionsByLocationData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiGetQuestionsByLocation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiGetQuestionsByLocationQueryKey(options),
  });
};

export const glacierPolicyFormsApiPostSaveQuestionsAnswersLocationQueryKey = (
  options: Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationData>
) => [
  createQueryKey(
    'glacierPolicyFormsApiPostSaveQuestionsAnswersLocation',
    options
  ),
];

export const glacierPolicyFormsApiPostSaveQuestionsAnswersLocationOptions = (
  options: Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await glacierPolicyFormsApiPostSaveQuestionsAnswersLocation({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      glacierPolicyFormsApiPostSaveQuestionsAnswersLocationQueryKey(options),
  });
};

export const glacierPolicyFormsApiPostSaveQuestionsAnswersLocationMutation = (
  options?: Partial<
    Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationData>
  >
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationResponse,
    GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationError,
    Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersLocationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } =
        await glacierPolicyFormsApiPostSaveQuestionsAnswersLocation({
          ...options,
          ...localOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyFormsApiGetQuestionsByEntityQueryKey = (
  options: Options<GlacierPolicyFormsApiGetQuestionsByEntityData>
) => [createQueryKey('glacierPolicyFormsApiGetQuestionsByEntity', options)];

export const glacierPolicyFormsApiGetQuestionsByEntityOptions = (
  options: Options<GlacierPolicyFormsApiGetQuestionsByEntityData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyFormsApiGetQuestionsByEntity({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyFormsApiGetQuestionsByEntityQueryKey(options),
  });
};

export const glacierPolicyFormsApiPostSaveQuestionsAnswersEntityQueryKey = (
  options: Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityData>
) => [
  createQueryKey(
    'glacierPolicyFormsApiPostSaveQuestionsAnswersEntity',
    options
  ),
];

export const glacierPolicyFormsApiPostSaveQuestionsAnswersEntityOptions = (
  options: Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } =
        await glacierPolicyFormsApiPostSaveQuestionsAnswersEntity({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
      return data;
    },
    queryKey:
      glacierPolicyFormsApiPostSaveQuestionsAnswersEntityQueryKey(options),
  });
};

export const glacierPolicyFormsApiPostSaveQuestionsAnswersEntityMutation = (
  options?: Partial<
    Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityData>
  >
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityResponse,
    GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityError,
    Options<GlacierPolicyFormsApiPostSaveQuestionsAnswersEntityData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } =
        await glacierPolicyFormsApiPostSaveQuestionsAnswersEntity({
          ...options,
          ...localOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyConditionsApiListBindingConditionsQueryKey = (
  options: Options<GlacierPolicyConditionsApiListBindingConditionsData>
) => [
  createQueryKey('glacierPolicyConditionsApiListBindingConditions', options),
];

export const glacierPolicyConditionsApiListBindingConditionsOptions = (
  options: Options<GlacierPolicyConditionsApiListBindingConditionsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyConditionsApiListBindingConditions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyConditionsApiListBindingConditionsQueryKey(options),
  });
};

export const glacierPolicyConditionsApiCreateBindingConditionQueryKey = (
  options: Options<GlacierPolicyConditionsApiCreateBindingConditionData>
) => [
  createQueryKey('glacierPolicyConditionsApiCreateBindingCondition', options),
];

export const glacierPolicyConditionsApiCreateBindingConditionOptions = (
  options: Options<GlacierPolicyConditionsApiCreateBindingConditionData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyConditionsApiCreateBindingCondition({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyConditionsApiCreateBindingConditionQueryKey(options),
  });
};

export const glacierPolicyConditionsApiCreateBindingConditionMutation = (
  options?: Partial<
    Options<GlacierPolicyConditionsApiCreateBindingConditionData>
  >
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyConditionsApiCreateBindingConditionResponse,
    GlacierPolicyConditionsApiCreateBindingConditionError,
    Options<GlacierPolicyConditionsApiCreateBindingConditionData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyConditionsApiCreateBindingCondition({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyConditionsApiUpdateBindingConditionMutation = (
  options?: Partial<
    Options<GlacierPolicyConditionsApiUpdateBindingConditionData>
  >
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyConditionsApiUpdateBindingConditionResponse,
    GlacierPolicyConditionsApiUpdateBindingConditionError,
    Options<GlacierPolicyConditionsApiUpdateBindingConditionData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyConditionsApiUpdateBindingCondition({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyConditionsApiDeleteBindingConditionMutation = (
  options?: Partial<
    Options<GlacierPolicyConditionsApiDeleteBindingConditionData>
  >
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyConditionsApiDeleteBindingConditionResponse,
    GlacierPolicyConditionsApiDeleteBindingConditionError,
    Options<GlacierPolicyConditionsApiDeleteBindingConditionData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyConditionsApiDeleteBindingCondition({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyConditionsApiListTermsConditionsQueryKey = (
  options: Options<GlacierPolicyConditionsApiListTermsConditionsData>
) => [createQueryKey('glacierPolicyConditionsApiListTermsConditions', options)];

export const glacierPolicyConditionsApiListTermsConditionsOptions = (
  options: Options<GlacierPolicyConditionsApiListTermsConditionsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyConditionsApiListTermsConditions({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyConditionsApiListTermsConditionsQueryKey(options),
  });
};

export const glacierPolicyConditionsApiCreateTermsConditionQueryKey = (
  options: Options<GlacierPolicyConditionsApiCreateTermsConditionData>
) => [
  createQueryKey('glacierPolicyConditionsApiCreateTermsCondition', options),
];

export const glacierPolicyConditionsApiCreateTermsConditionOptions = (
  options: Options<GlacierPolicyConditionsApiCreateTermsConditionData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyConditionsApiCreateTermsCondition({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyConditionsApiCreateTermsConditionQueryKey(options),
  });
};

export const glacierPolicyConditionsApiCreateTermsConditionMutation = (
  options?: Partial<Options<GlacierPolicyConditionsApiCreateTermsConditionData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyConditionsApiCreateTermsConditionResponse,
    GlacierPolicyConditionsApiCreateTermsConditionError,
    Options<GlacierPolicyConditionsApiCreateTermsConditionData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyConditionsApiCreateTermsCondition({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyConditionsApiUpdateTermsConditionMutation = (
  options?: Partial<Options<GlacierPolicyConditionsApiUpdateTermsConditionData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyConditionsApiUpdateTermsConditionResponse,
    GlacierPolicyConditionsApiUpdateTermsConditionError,
    Options<GlacierPolicyConditionsApiUpdateTermsConditionData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyConditionsApiUpdateTermsCondition({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyConditionsApiDeleteTermsConditionMutation = (
  options?: Partial<Options<GlacierPolicyConditionsApiDeleteTermsConditionData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyConditionsApiDeleteTermsConditionResponse,
    GlacierPolicyConditionsApiDeleteTermsConditionError,
    Options<GlacierPolicyConditionsApiDeleteTermsConditionData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyConditionsApiDeleteTermsCondition({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyErpApiGetErpEligibleDatesQueryKey = (
  options: Options<GlacierPolicyErpApiGetErpEligibleDatesData>
) => [createQueryKey('glacierPolicyErpApiGetErpEligibleDates', options)];

export const glacierPolicyErpApiGetErpEligibleDatesOptions = (
  options: Options<GlacierPolicyErpApiGetErpEligibleDatesData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyErpApiGetErpEligibleDates({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyErpApiGetErpEligibleDatesQueryKey(options),
  });
};

export const glacierPolicyErpApiGetErpSectionsQueryKey = (
  options: Options<GlacierPolicyErpApiGetErpSectionsData>
) => [createQueryKey('glacierPolicyErpApiGetErpSections', options)];

export const glacierPolicyErpApiGetErpSectionsOptions = (
  options: Options<GlacierPolicyErpApiGetErpSectionsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyErpApiGetErpSections({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyErpApiGetErpSectionsQueryKey(options),
  });
};

export const glacierPolicyErpApiStartErpEndorsementQueryKey = (
  options: Options<GlacierPolicyErpApiStartErpEndorsementData>
) => [createQueryKey('glacierPolicyErpApiStartErpEndorsement', options)];

export const glacierPolicyErpApiStartErpEndorsementOptions = (
  options: Options<GlacierPolicyErpApiStartErpEndorsementData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyErpApiStartErpEndorsement({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyErpApiStartErpEndorsementQueryKey(options),
  });
};

export const glacierPolicyErpApiStartErpEndorsementMutation = (
  options?: Partial<Options<GlacierPolicyErpApiStartErpEndorsementData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyErpApiStartErpEndorsementResponse,
    GlacierPolicyErpApiStartErpEndorsementError,
    Options<GlacierPolicyErpApiStartErpEndorsementData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyErpApiStartErpEndorsement({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierPolicyErpApiSaveErpSelectionsQueryKey = (
  options: Options<GlacierPolicyErpApiSaveErpSelectionsData>
) => [createQueryKey('glacierPolicyErpApiSaveErpSelections', options)];

export const glacierPolicyErpApiSaveErpSelectionsOptions = (
  options: Options<GlacierPolicyErpApiSaveErpSelectionsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierPolicyErpApiSaveErpSelections({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierPolicyErpApiSaveErpSelectionsQueryKey(options),
  });
};

export const glacierPolicyErpApiSaveErpSelectionsMutation = (
  options?: Partial<Options<GlacierPolicyErpApiSaveErpSelectionsData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierPolicyErpApiSaveErpSelectionsResponse,
    GlacierPolicyErpApiSaveErpSelectionsError,
    Options<GlacierPolicyErpApiSaveErpSelectionsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierPolicyErpApiSaveErpSelections({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierOneschemaApiGetJwtTokenQueryKey = (options?: Options) => [
  createQueryKey('glacierOneschemaApiGetJwtToken', options),
];

export const glacierOneschemaApiGetJwtTokenOptions = (options?: Options) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierOneschemaApiGetJwtToken({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierOneschemaApiGetJwtTokenQueryKey(options),
  });
};

export const glacierOneschemaApiBulkUploadPoliciesQueryKey = (
  options: Options<GlacierOneschemaApiBulkUploadPoliciesData>
) => [createQueryKey('glacierOneschemaApiBulkUploadPolicies', options)];

export const glacierOneschemaApiBulkUploadPoliciesOptions = (
  options: Options<GlacierOneschemaApiBulkUploadPoliciesData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierOneschemaApiBulkUploadPolicies({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierOneschemaApiBulkUploadPoliciesQueryKey(options),
  });
};

export const glacierOneschemaApiBulkUploadPoliciesMutation = (
  options?: Partial<Options<GlacierOneschemaApiBulkUploadPoliciesData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierOneschemaApiBulkUploadPoliciesResponse,
    GlacierOneschemaApiBulkUploadPoliciesError,
    Options<GlacierOneschemaApiBulkUploadPoliciesData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierOneschemaApiBulkUploadPolicies({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierOneschemaApiBulkUploadDentistsQueryKey = (
  options: Options<GlacierOneschemaApiBulkUploadDentistsData>
) => [createQueryKey('glacierOneschemaApiBulkUploadDentists', options)];

export const glacierOneschemaApiBulkUploadDentistsOptions = (
  options: Options<GlacierOneschemaApiBulkUploadDentistsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierOneschemaApiBulkUploadDentists({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierOneschemaApiBulkUploadDentistsQueryKey(options),
  });
};

export const glacierOneschemaApiBulkUploadDentistsMutation = (
  options?: Partial<Options<GlacierOneschemaApiBulkUploadDentistsData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierOneschemaApiBulkUploadDentistsResponse,
    GlacierOneschemaApiBulkUploadDentistsError,
    Options<GlacierOneschemaApiBulkUploadDentistsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierOneschemaApiBulkUploadDentists({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierOneschemaApiBulkUploadLocationsQueryKey = (
  options: Options<GlacierOneschemaApiBulkUploadLocationsData>
) => [createQueryKey('glacierOneschemaApiBulkUploadLocations', options)];

export const glacierOneschemaApiBulkUploadLocationsOptions = (
  options: Options<GlacierOneschemaApiBulkUploadLocationsData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierOneschemaApiBulkUploadLocations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierOneschemaApiBulkUploadLocationsQueryKey(options),
  });
};

export const glacierOneschemaApiBulkUploadLocationsMutation = (
  options?: Partial<Options<GlacierOneschemaApiBulkUploadLocationsData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierOneschemaApiBulkUploadLocationsResponse,
    GlacierOneschemaApiBulkUploadLocationsError,
    Options<GlacierOneschemaApiBulkUploadLocationsData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierOneschemaApiBulkUploadLocations({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierAgenciesApiListWritingCompanyQueryKey = (
  options?: Options
) => [createQueryKey('glacierAgenciesApiListWritingCompany', options)];

export const glacierAgenciesApiListWritingCompanyOptions = (
  options?: Options
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierAgenciesApiListWritingCompany({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierAgenciesApiListWritingCompanyQueryKey(options),
  });
};

export const glacierNewGradApiValidateAgencyQueryKey = (
  options: Options<GlacierNewGradApiValidateAgencyData>
) => [createQueryKey('glacierNewGradApiValidateAgency', options)];

export const glacierNewGradApiValidateAgencyOptions = (
  options: Options<GlacierNewGradApiValidateAgencyData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierNewGradApiValidateAgency({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierNewGradApiValidateAgencyQueryKey(options),
  });
};

export const glacierNewGradApiValidateAgencyMutation = (
  options?: Partial<Options<GlacierNewGradApiValidateAgencyData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierNewGradApiValidateAgencyResponse,
    GlacierNewGradApiValidateAgencyError,
    Options<GlacierNewGradApiValidateAgencyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierNewGradApiValidateAgency({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierNewGradApiSaveAnswersQueryKey = (
  options: Options<GlacierNewGradApiSaveAnswersData>
) => [createQueryKey('glacierNewGradApiSaveAnswers', options)];

export const glacierNewGradApiSaveAnswersOptions = (
  options: Options<GlacierNewGradApiSaveAnswersData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierNewGradApiSaveAnswers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierNewGradApiSaveAnswersQueryKey(options),
  });
};

export const glacierNewGradApiSaveAnswersMutation = (
  options?: Partial<Options<GlacierNewGradApiSaveAnswersData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierNewGradApiSaveAnswersResponse,
    GlacierNewGradApiSaveAnswersError,
    Options<GlacierNewGradApiSaveAnswersData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierNewGradApiSaveAnswers({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierNewGradApiGetAnswersQueryKey = (
  options: Options<GlacierNewGradApiGetAnswersData>
) => [createQueryKey('glacierNewGradApiGetAnswers', options)];

export const glacierNewGradApiGetAnswersOptions = (
  options: Options<GlacierNewGradApiGetAnswersData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierNewGradApiGetAnswers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierNewGradApiGetAnswersQueryKey(options),
  });
};

export const glacierNewGradApiPollPaymentQueryKey = (
  options: Options<GlacierNewGradApiPollPaymentData>
) => [createQueryKey('glacierNewGradApiPollPayment', options)];

export const glacierNewGradApiPollPaymentOptions = (
  options: Options<GlacierNewGradApiPollPaymentData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierNewGradApiPollPayment({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierNewGradApiPollPaymentQueryKey(options),
  });
};

export const glacierNewGradApiPollPaymentMutation = (
  options?: Partial<Options<GlacierNewGradApiPollPaymentData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierNewGradApiPollPaymentResponse,
    GlacierNewGradApiPollPaymentError,
    Options<GlacierNewGradApiPollPaymentData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierNewGradApiPollPayment({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierNewGradApiDownloadQuoteQueryKey = (
  options: Options<GlacierNewGradApiDownloadQuoteData>
) => [createQueryKey('glacierNewGradApiDownloadQuote', options)];

export const glacierNewGradApiDownloadQuoteOptions = (
  options: Options<GlacierNewGradApiDownloadQuoteData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierNewGradApiDownloadQuote({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierNewGradApiDownloadQuoteQueryKey(options),
  });
};

export const glacierNewGradApiDownloadQuoteMutation = (
  options?: Partial<Options<GlacierNewGradApiDownloadQuoteData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierNewGradApiDownloadQuoteResponse,
    GlacierNewGradApiDownloadQuoteError,
    Options<GlacierNewGradApiDownloadQuoteData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierNewGradApiDownloadQuote({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const glacierNewGradApiDownloadPolicyQueryKey = (
  options: Options<GlacierNewGradApiDownloadPolicyData>
) => [createQueryKey('glacierNewGradApiDownloadPolicy', options)];

export const glacierNewGradApiDownloadPolicyOptions = (
  options: Options<GlacierNewGradApiDownloadPolicyData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await glacierNewGradApiDownloadPolicy({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: glacierNewGradApiDownloadPolicyQueryKey(options),
  });
};

export const glacierNewGradApiDownloadPolicyMutation = (
  options?: Partial<Options<GlacierNewGradApiDownloadPolicyData>>
) => {
  const mutationOptions: UseMutationOptions<
    GlacierNewGradApiDownloadPolicyResponse,
    GlacierNewGradApiDownloadPolicyError,
    Options<GlacierNewGradApiDownloadPolicyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await glacierNewGradApiDownloadPolicy({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};
